import { Icon } from './Icon/index.esm.js';
export { getIconSizeDefault, getIconVariantDefault } from './Icon/index.esm.js';
import { jsx } from 'react/jsx-runtime';
import 'react';
import '@skatteetaten/ds-core-utils';

const iconVariantArr = [
    'systemIcon',
    'themeIcon'
];

const AccountArrowBackSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M17 18h4v-2h-4v-2l-3 3 3 3zM11 4C8.8 4 7 5.8 7 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m0 10c-4.4 0-8 1.8-8 4v2h9.5c-.3-.8-.5-1.6-.5-2.5 0-1.2.3-2.3.9-3.4-.6 0-1.2-.1-1.9-.1'
});
function AccountArrowBackIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AccountArrowBackSVGpath
    });
}

const AccountBoxSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M6 17c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1Zm9-8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2Z'
});
function AccountBoxIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AccountBoxSVGpath
    });
}

const AccountChildSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12.5 11a2 2 0 1 0-.09 3.998A2 2 0 0 0 12.5 11Zm0-2c1.63 0 3.12.35 4.5 1.05 1.34.71 2 1.56 2 2.56v5.77c0 1.12-.86 2.06-2.61 2.81V19c0-.95-.86-1.62-2.58-2.03-.56-.13-1-.19-1.31-.19-.87 0-1.7.17-2.46.52-.77.34-1.23.78-1.38 1.31 1.34.53 2.62.8 3.84.8l1-.1v2.63l-1 .06a9.68 9.68 0 0 1-3.89-.81C6.86 20.44 6 19.5 6 18.38v-5.77c0-1 .66-1.85 2-2.56C9.38 9.35 10.88 9 12.5 9Zm0-7a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z'
});
function AccountChildIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AccountChildSVGpath
    });
}

const AccountEnkSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18 13c.6 0 1 .4 1 .9v.9h2c.6 0 1 .4 1 .9v4.2c0 .5-.4.9-1 .9h-8c-.6 0-1-.4-1-.9v-4.2c0-.5.4-.9 1-.9h2v-.9c0-.5.4-.9 1-.9h2Zm-8 0c.6 0 1.1 0 1.6.1-.1.2-2.3 1.3-1.7 5.9H2v-2c0-2.2 3.6-4 8-4Zm8 1h-2v.899h2V14ZM10 3c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4Z'
});
function AccountEnkIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AccountEnkSVGpath
    });
}

const AccountMultipleSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15.94 14c5.735.35 6.043 3.62 6.06 3.97V20h-4v-2a5.321 5.321 0 0 0-2.06-4ZM9 14c6.65 0 6.982 3.61 7 3.971V20H2v-2.029C2.019 17.61 2.35 14 9 14Zm6-9a3.5 3.5 0 1 1 0 7 3.39 3.39 0 0 1-1.93-.59 5.001 5.001 0 0 0 0-5.82A3.39 3.39 0 0 1 15 5ZM9 5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z'
});
function AccountMultipleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AccountMultipleSVGpath
    });
}

const AddSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19 10.75H13.25V5H10.75V10.75H5V13.25H10.75V19H13.25V13.25H19V10.75Z'
});
function AddIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AddSVGpath
    });
}

const AddOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-18C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Zm1 5h-2v4H7v2h4v4h2v-4h4v-2h-4V7Z'
});
function AddOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AddOutlineSVGpath
    });
}

const ArchiveSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M3 3h18v4H3V3m1 5h16v13H4V8m5.5 3a.5.5 0 0 0-.5.5V13h6v-1.5a.5.5 0 0 0-.5-.5h-5Z'
});
function ArchiveIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ArchiveSVGpath
    });
}

const ArchiveOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M20 21H4V10h2v9h12v-9h2v11M3 3h18v6H3V3m6.5 8h5c.28 0 .5.22.5.5V13H9v-1.5c0-.28.22-.5.5-.5M5 5v2h14V5H5Z'
});
function ArchiveOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ArchiveOutlineSVGpath
    });
}

const ArrowBackSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M9.86 4.5L3 12.5L9.86 20.5L11.8 18.83L7.45 13.75H21V11.25L7.45 11.25L11.8 6.17L9.86 4.5Z'
});
function ArrowBackIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ArrowBackSVGpath
    });
}

const ArrowDownSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M4 14.64L12 21.5L20 14.64L18.33 12.7L13.25 17.05L13.25 3.5H10.75L10.75 17.05L5.67 12.7L4 14.64Z'
});
function ArrowDownIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ArrowDownSVGpath
    });
}

const ArrowForwardSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M14.14 20.5L21 12.5L14.14 4.5L12.2 6.17L16.55 11.25L3 11.25V13.75L16.55 13.75L12.2 18.83L14.14 20.5Z'
});
function ArrowForwardIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ArrowForwardSVGpath
    });
}

const ArrowUpSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M20 9.86L12 3L4 9.86L5.67 11.8L10.75 7.45V21H13.25V7.45L18.33 11.8L20 9.86Z'
});
function ArrowUpIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ArrowUpSVGpath
    });
}

const ArrowUpDownSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M7 4L12 8.95937L10.6364 10.2719L7.96364 7.61875V20H6.03636V7.61875L3.36364 10.2719L2 8.95937L7 4ZM17 21L12 16.0406L13.3636 14.7281L16.0364 17.3813V5H17.9636V17.3813L20.6364 14.7281L22 16.0406L17 21Z',
    fillRule: 'evenodd',
    clipRule: 'evenodd'
});
function ArrowUpDownIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ArrowUpDownSVGpath
    });
}

const AttachFileSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M16.5 6v11.5a4 4 0 1 1-8 0V5a2.5 2.5 0 1 1 5 0v10.5a1 1 0 0 1-2 0V6H10v9.5a2.5 2.5 0 0 0 5 0V5a4 4 0 1 0-8 0v12.5a5.5 5.5 0 0 0 11 0V6h-1.5Z'
});
function AttachFileIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AttachFileSVGpath
    });
}

const BellSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M17.33 10.2V13.8H17.31L19.98 15.6V18.3H3.98V15.6L6.65 13.8V10.2C6.65 7.84 8.15 5.83 10.24 5.1C10.22 5 10.21 4.9 10.21 4.8C10.21 3.81 11.01 3 11.99 3C12.97 3 13.77 3.81 13.77 4.8C13.77 4.9 13.76 5 13.74 5.1C15.83 5.84 17.33 7.84 17.33 10.2ZM13.78 19.2C13.78 20.19 12.98 21 12 21C11.02 21 10.22 20.19 10.22 19.2H13.78Z',
    fillRule: 'evenodd',
    clipRule: 'evenodd'
});
function BellIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BellSVGpath
    });
}

const BellOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M17.33 10.2V13.8H17.32L19.99 15.6V18.3H3.99001V15.6L6.66001 13.8V10.2C6.66001 8.48 7.46001 6.95 8.70001 5.97C8.77001 5.91 8.84001 5.86 8.90001 5.82C9.31001 5.52 9.77001 5.28 10.26 5.11L10.26 5.10999C10.24 5.01 10.22 4.91 10.22 4.8C10.22 3.81 11.01 3 12 3C12.99 3 13.78 3.81 13.78 4.8C13.78 4.91 13.77 5.01 13.75 5.11C14.24 5.28 14.69 5.51 15.1 5.82C15.18 5.87 15.25 5.92 15.31 5.98C16.55 6.97 17.33 8.49 17.33 10.2ZM10.13 7.69C9.36001 8.27 8.89001 9.19 8.89001 10.2H8.88001V16.05H15.1V10.2C15.1 9.28 14.71 8.43 14.05 7.84C13.98 7.77 13.89 7.7 13.81 7.65C13.75 7.6 13.68 7.56 13.61 7.52L13.61 7.52C13.13 7.25 12.58 7.1 11.99 7.1C11.4 7.1 10.86 7.25 10.38 7.52C10.3495 7.54179 10.319 7.55978 10.2893 7.57728C10.2509 7.59994 10.2139 7.62179 10.18 7.65C10.1779 7.65215 10.1752 7.65523 10.1723 7.65874C10.1614 7.67153 10.1457 7.69 10.13 7.69ZM13.78 19.2C13.78 20.19 12.98 21 12 21C11.02 21 10.22 20.19 10.22 19.2H13.78Z'
});
function BellOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BellOutlineSVGpath
    });
}

const BlockedSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10a10 10 0 0 1 0-20Zm0 2a8 8 0 0 0-8 8c0 1.85.63 3.55 1.68 4.91L16.91 5.68A8.005 8.005 0 0 0 12 4Zm0 16a8 8 0 0 0 6.32-12.91L7.09 18.32A8.005 8.005 0 0 0 12 20Z'
});
function BlockedIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BlockedSVGpath
    });
}

const BookOpenSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm19 2-5 4.5v11l5-4.5V2ZM6.5 5C4.55 5 2.45 5.4 1 6.5v14.66c0 .25.25.5.5.5.1 0 .15-.07.25-.07 1.35-.65 3.3-1.09 4.75-1.09 1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.31 4.75 1.06.1.05.15.03.25.03.25 0 .5-.25.5-.5V6.5c-.6-.45-1.25-.75-2-1V19c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V6.5C10.55 5.4 8.45 5 6.5 5Z'
});
function BookOpenIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BookOpenSVGpath
    });
}

const BookOpenOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M21 4H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM3 19V6h8v13H3Zm18 0h-8V6h8v13Zm-7-9.5h6V11h-6V9.5Zm0 2.5h6v1.5h-6V12Zm0 2.5h6V16h-6v-1.5Z'
});
function BookOpenOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BookOpenOutlineSVGpath
    });
}

const BookmarkSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M17.1429 4H7.85714C7.3646 4 6.89223 4.19901 6.54394 4.55324C6.19566 4.90748 6 5.38792 6 5.88889V21L12.5 18.1667L19 21V5.88889C19 5.38792 18.8043 4.90748 18.4561 4.55324C18.1078 4.19901 17.6354 4 17.1429 4Z'
});
function BookmarkIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BookmarkSVGpath
    });
}

const BookmarkOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 15.4395L16.3077 17.1831V6.5H7.69231V17.1831L12 15.4395ZM5 21V5.88889C5 5.38792 5.21071 4.90748 5.58579 4.55324C5.96086 4.19901 6.46957 4 7 4H17C17.5304 4 18.0391 4.19901 18.4142 4.55324C18.7893 4.90748 19 5.38792 19 5.88889V21L12 18.1667L5 21Z'
});
function BookmarOutlinekIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BookmarkOutlineSVGpath
    });
}

const BriefcaseSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2Zm4 4V4h-4v2h4Z'
});
function BriefcaseIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BriefcaseSVGpath
    });
}

const BriefcaseMultipleSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M20.89 8.51v9.99c0 .55-.45 1-1 1H4.66c0 1.1.89 1.5 2 1.5h14c.91 0 1.73-.53 1.73-1.5v-9c0-1.02-.51-1.87-1.5-1.99 M9 1.5h4c1.1 0 2 .9 2 2v2h3c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-9c0-1.11.89-2 2-2h3v-2c0-1.11.89-2 2-2m4 4v-2H9v2z'
});
function BriefcaseMultipleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BriefcaseMultipleSVGpath
    });
}

const BriefcaseOffSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M21,8.5v9c0,1.1-.9,2-2,2H7.9l12.7-12.2c.3.3.4.7.4,1.2Z M21.6,3.7l-.4-.4-1-1-4.2,4v-1.8c0-1.1-.9-2-2-2h-4c-1.1,0-2,.9-2,2v2h-3c-1.1,0-2,.9-2,2v9c0,.4.1.7.3,1l-1.9,1.8,1.4,1.4h0S21.6,3.7,21.6,3.7ZM10,4.5h4v2h-4v-2Z'
});
function BriefcaseOffIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BriefcaseOffSVGpath
    });
}

const CalculatorSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm0 2v4h10V4H7Zm0 6v2h2v-2H7Zm4 0v2h2v-2h-2Zm4 0v2h2v-2h-2Zm-8 4v2h2v-2H7Zm4 0v2h2v-2h-2Zm4 0v2h2v-2h-2Zm-8 4v2h2v-2H7Zm4 0v2h2v-2h-2Zm4 0v2h2v-2h-2Z'
});
function CalculatorIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CalculatorSVGpath
    });
}

const CalendarSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19 19H5V8h14v11ZM16 1v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1h-2Zm1 11h-5v5h5v-5Z'
});
function CalendarIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CalendarSVGpath
    });
}

const CalendarClockSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15 13h1.5v2.82l2.44 1.41-.75 1.3L15 16.69V13Zm4-5H5v11h4.67c-.43-.91-.67-1.93-.67-3a7 7 0 0 1 7-7c1.07 0 2.09.24 3 .67V8ZM5 21a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 0 1-7 7c-1.91 0-3.64-.76-4.9-2H5Zm11-9.85a4.85 4.85 0 1 0 0 9.7 4.85 4.85 0 0 0 0-9.7Z'
});
function CalendarClockIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CalendarClockSVGpath
    });
}

const CancelSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19 17.61L13.89 12.5L19 7.39L17.11 5.5L12 10.61L6.89 5.5L5 7.39L10.11 12.5L5 17.61L6.89 19.5L12 14.39L17.11 19.5L19 17.61Z'
});
function CancelIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CancelSVGpath
    });
}

const CashRefundSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M3 11h18v12H3V11Zm9 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm-5-2a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2v-4a2 2 0 0 1-2-2H7Zm10-8v5h-1.5V6.5H9.88l2.42 2.43L11.24 10 7 5.75l4.24-4.25 1.06 1.07L9.88 5H17Z'
});
function CashRefundIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CashRefundSVGpath
    });
}

const ChatBubbleSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M9 22.5C8.73478 22.5 8.48043 22.3946 8.29289 22.2071C8.10536 22.0196 8 21.7652 8 21.5V18.5H4C3.46957 18.5 2.96086 18.2893 2.58579 17.9142C2.21071 17.5391 2 17.0304 2 16.5V6.5C2 5.96957 2.21071 5.46086 2.58579 5.08579C2.96086 4.71071 3.46957 4.5 4 4.5H20C20.5304 4.5 21.0391 4.71071 21.4142 5.08579C21.7893 5.46086 22 5.96957 22 6.5V16.5C22 17.0304 21.7893 17.5391 21.4142 17.9142C21.0391 18.2893 20.5304 18.5 20 18.5H13.9L10.2 22.21C10 22.4 9.75 22.5 9.5 22.5H9Z'
});
function ChatBubbleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChatBubbleSVGpath
    });
}

const ChatBubbleOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M10.5 18.3689L12.8625 16H19.5V7H4.5V16H10.5V18.3689ZM10.2 22.21L13.9 18.5H20C20.5304 18.5 21.0391 18.2893 21.4142 17.9142C21.7893 17.5391 22 17.0304 22 16.5V6.5C22 5.96957 21.7893 5.46086 21.4142 5.08579C21.0391 4.71071 20.5304 4.5 20 4.5H4C3.46957 4.5 2.96086 4.71071 2.58579 5.08579C2.21071 5.46086 2 5.96957 2 6.5V16.5C2 17.0304 2.21071 17.5391 2.58579 17.9142C2.96086 18.2893 3.46957 18.5 4 18.5H8V21.5C8 21.7652 8.10536 22.0196 8.29289 22.2071C8.48043 22.3946 8.73478 22.5 9 22.5H9.5C9.75 22.5 10 22.4 10.2 22.21Z',
    fillRule: 'evenodd',
    clipRule: 'evenodd'
});
function ChatBubbleOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChatBubbleOutlineSVGpath
    });
}

const ChatbotSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18.069 7.261c.597 0 1.069.524 1.028 1.141l-.872 11.623c-.042.55-.484.975-1.021.975H6.799c-.537 0-.986-.426-1.028-.975L4.906 8.402c-.048-.617.424-1.14 1.02-1.14l12.143-.001Zm-3.935 9.64H9.57a.213.213 0 0 0-.153.365l1.42 1.417c.56.556 1.47.556 2.03 0l1.419-1.417a.212.212 0 0 0-.152-.366v.001Zm6.84-5.137c.566 0 1.025.46 1.025 1.026v2.19c0 .527-.4.963-.913 1.018l-.112.006a1.026 1.026 0 0 1-1.026-1.025V12.79c0-.567.46-1.026 1.026-1.026Zm-17.949 0c.566 0 1.026.46 1.026 1.026v2.19c0 .527-.4.963-.914 1.018l-.112.006A1.025 1.025 0 0 1 2 14.98v-2.19c0-.567.459-1.026 1.025-1.026Zm13.604.151h-1.5v3.5h1.5v-3.5Zm-7.755 0h-1.5v3.5h1.5v-3.5ZM12 3c.708 0 1.282.594 1.282 1.325 0 .732-.574 1.325-1.282 1.325-.708 0-1.282-.593-1.282-1.325C10.718 3.594 11.292 3 12 3Z'
});
function ChatbotIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChatbotSVGpath
    });
}

const CheckSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19.94 6.71L19.24 6L9 16.23L5.26 12.5L4.91 12.85L3.5 14.26L9 19.76L21 7.76L19.94 6.71Z'
});
function CheckIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CheckSVGpath
    });
}

const ChevronDownSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18.1 7.98001L12 14.08L5.9 7.98001L4 9.88L12 17.88L20 9.88L18.1 7.98001Z'
});
function ChevronDownIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChevronDownSVGpath
    });
}

const ChevronDownDoubleSVGpath = /*#__PURE__*/ jsx("path", {
    fillRule: 'evenodd',
    d: 'M18.34 5.5 20 7.45l-8 6.85-8-6.85L5.67 5.5l5.08 4.36L12 10.93l1.25-1.07zM12 18.13l1.25-1.07 5.09-4.36L20 14.65l-8 6.85-8-6.85 1.67-1.95 5.08 4.36z',
    clipRule: 'evenodd'
});
function ChevronDownDoubleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChevronDownDoubleSVGpath
    });
}

const ChevronLeftSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15.9 17.98L9.8 11.88L15.9 5.78L14.1 3.88L6.1 11.88L14.1 19.88L15.9 17.98Z'
});
function ChevronLeftIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChevronLeftSVGpath
    });
}

const ChevronLeftDoubleSVGpath = /*#__PURE__*/ jsx("path", {
    fillRule: 'evenodd',
    d: 'M19 18.34 17.05 20l-6.85-8 6.85-8L19 5.67l-4.36 5.08L13.57 12l1.07 1.25zM6.37 12l1.07 1.25 4.36 5.09L9.85 20 3 12l6.85-8 1.95 1.67-4.36 5.08z',
    clipRule: 'evenodd'
});
function ChevronLeftDoubleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChevronLeftDoubleSVGpath
    });
}

const ChevronRightSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M8.10001 5.80002L14.2 11.9L8.10001 18L10 19.9L18 11.9L10 3.90002L8.10001 5.80002Z'
});
function ChevronRightIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChevronRightSVGpath
    });
}

const ChevronRightDoubleSVGpath = /*#__PURE__*/ jsx("path", {
    fillRule: 'evenodd',
    d: 'M5 5.66 6.95 4l6.85 8-6.85 8L5 18.33l4.36-5.08L10.43 12l-1.07-1.25zM17.63 12l-1.07-1.25-4.36-5.09L14.15 4 21 12l-6.85 8-1.95-1.67 4.36-5.08z',
    clipRule: 'evenodd'
});
function ChevronRightDoubleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChevronRightDoubleSVGpath
    });
}

const ChevronUpSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M5.88 16.88L12 10.773L18.12 16.88L20 15L12 7L4 15L5.88 16.88Z'
});
function ChevronUpIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChevronUpSVGpath
    });
}

const ChevronUpDoubleSVGpath = /*#__PURE__*/ jsx("path", {
    fillRule: 'evenodd',
    d: 'M5.66 19.5 4 17.55l8-6.85 8 6.85-1.67 1.95-5.08-4.36L12 14.07l-1.25 1.07zM12 6.87l-1.25 1.07-5.09 4.36L4 10.35l8-6.85 8 6.85-1.67 1.95-5.08-4.36z',
    clipRule: 'evenodd'
});
function ChevronUpDoubleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChevronUpDoubleSVGpath
    });
}

const CircleDownSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M22 12c0 5.523-4.477 10-10 10a10 10 0 1 1 10-10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM6 10l6 6 6-6-1.4-1.4-4.6 4.6-4.6-4.6L6 10Z'
});
function CircleDownIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CircleDownSVGpath
    });
}

const CircleFilledSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Z'
});
function CircleFilledIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CircleFilledSVGpath
    });
}

const CircleRingSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm0-18a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z'
});
function CircleRingIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CircleRingSVGpath
    });
}

const CircleUpSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M22 12c0 5.523-4.477 10-10 10a10 10 0 1 1 10-10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM7.4 15.4l4.6-4.6 4.6 4.6L18 14l-6-6-6 6 1.4 1.4Z'
});
function CircleUpIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CircleUpSVGpath
    });
}

const ClockSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m4.3 13.2L11 12.3V7h1.5v4.4l4.5 2.5z'
});
function ClockIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ClockSVGpath
    });
}

const ClockOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2m5 11.9-.7 1.3-5.3-2.9V7h1.5v4.4z'
});
function ClockOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ClockOutlineSVGpath
    });
}

const CloudSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M6 19A5 5 0 0 1 6 9c1-2.35 3.3-4 6-4 3.43 0 6.24 2.66 6.5 6.03L19 11a4 4 0 1 1 0 8H6Zm13-6h-2v-1a5.004 5.004 0 0 0-9.94-.81C6.73 11.07 6.37 11 6 11a3 3 0 0 0 0 6h13a2 2 0 0 0 0-4Z'
});
function CloudIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CloudSVGpath
    });
}

const CloudUploadSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04a5.994 5.994 0 0 0-3.593 10.203A6 6 0 0 0 6 20h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.96ZM19 18H6a4 4 0 0 1-4-4c0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.47 5.47 0 0 1 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0 1 22 15a3 3 0 0 1-3 3ZM8 13h2.55v3h2.9v-3H16l-4-4-4 4Z'
});
function CloudUploadIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CloudUploadSVGpath
    });
}

const CodeSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm14.6 16.6 4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4Zm-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4Z'
});
function CodeIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CodeSVGpath
    });
}

const CompanySVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15.9 12.05h-.05V8.5c0-.225-.25-.35-.425-.2L10.9 12.05V8.5c0-.225-.25-.35-.425-.2L5.95 12.05V3.175h-2.8v17.7h17.7V8.5c0-.225-.25-.35-.425-.2L15.9 12.05Z'
});
function CompanyIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CompanySVGpath
    });
}

const CompanyGroupSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19.25,16.37v-2.72c1-.26,1.75-1.18,1.75-2.27,0-1.3-1.04-2.36-2.33-2.36-1.08,0-1.99.75-2.25,1.77h-2.17c-.21-.83-.85-1.47-1.67-1.68v-2.47c1-.26,1.75-1.18,1.75-2.27,0-1.3-1.04-2.36-2.33-2.36s-2.33,1.06-2.33,2.36c0,1.1.74,2.01,1.75,2.27v2.47c-.82.21-1.45.86-1.67,1.68h-2.17c-.26-1.01-1.16-1.77-2.25-1.77-1.29,0-2.33,1.06-2.33,2.36,0,1.1.74,2.01,1.75,2.27v2.72c-1,.26-1.75,1.18-1.75,2.27,0,1.3,1.04,2.36,2.33,2.36s2.33-1.06,2.33-2.36c0-1.1-.74-2.01-1.75-2.27v-2.72c.82-.21,1.45-.86,1.67-1.68h2.17c.21.83.85,1.47,1.67,1.68v2.72c-1,.26-1.75,1.18-1.75,2.27,0,1.3,1.04,2.36,2.33,2.36s2.33-1.06,2.33-2.36c0-1.1-.74-2.01-1.75-2.27v-2.72c.82-.21,1.45-.86,1.67-1.68h2.17c.21.83.85,1.47,1.67,1.68v2.72c-1,.26-1.75,1.18-1.75,2.27,0,1.3,1.04,2.36,2.33,2.36s2.33-1.06,2.33-2.36c0-1.1-.74-2.01-1.75-2.27Z'
});
function CompanyGroupIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CompanyGroupSVGpath
    });
}

const CompletedSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10a10 10 0 0 1 0-20Zm-1 14.5 7-7-1.41-1.41L11 13.67l-3.09-3.08L6.5 12l4.5 4.5Z'
});
function CompletedIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CompletedSVGpath
    });
}

const CopySVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19 21H8V7h11v14Zm0-16H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm-3-4H4a2 2 0 0 0-2 2v14h2V3h12V1Z'
});
function CopyIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CopySVGpath
    });
}

const DeleteSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M9 3v1H4v2h1v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h1V4h-5V3H9ZM7 6h10v13H7V6Zm2 2v9h2V8H9Zm4 0v9h2V8h-2Z'
});
function DeleteIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: DeleteSVGpath
    });
}

const DeploySVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm2.19 19.169 4.09-4.08c-.21-.3-.36-.62-.45-.97l-3.64 3.64v1.41Zm0 2.83H3.6l4.77-4.76-1.42-1.41-4.76 4.76v1.41Zm4.24 0 3.64-3.64c-.34-.09-.67-.24-.97-.45l-4.08 4.09h1.41Zm2.64-5.47-1.41-1.41 1.41 1.41Zm5.66-7.07c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .77.78.78 2.05 0 2.83-.78.78-2.05.78-2.83 0Zm7.07-7.07S16.85.268 11.19 5.929c-2.19 2.19-3.5 4.6-4.35 6.71-.28.75-.09 1.57.46 2.13l2.13 2.12c.55.56 1.37.74 2.12.46a19.1 19.1 0 0 0 6.71-4.35c5.66-5.66 3.54-10.61 3.54-10.61ZM5.83 12.499 2 10.869l6.1-2.77c-.91 1.36-1.69 2.83-2.27 4.4Zm7.49 9.69-1.63-3.83c1.57-.58 3.04-1.36 4.4-2.27l-2.77 6.1Z'
});
function DeployIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: DeploySVGpath
    });
}

const DescriptionSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6Zm0 2h7v5h5v11H6V4Zm2 8v2h8v-2H8Zm0 4v2h5v-2H8Z'
});
function DescriptionIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: DescriptionSVGpath
    });
}

const DownloadSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M5 20h14v-2H5v2ZM19 9h-4V3H9v6H5l7 7 7-7Z'
});
function DownloadIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: DownloadSVGpath
    });
}

const DuplicateSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M20 21V7H9v6H7V7a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2h2v2h11Zm-8-4H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12v2H5v12h7v-2l4 3-4 3v-2Z'
});
function DuplicateIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: DuplicateSVGpath
    });
}

const EarthSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M17.9 17.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41a7.984 7.984 0 0 1 2.9 12.8ZM11 19.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.22.21-1.79L9 15v1a2 2 0 0 0 2 2v1.93ZM12 2C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Z'
});
function EarthIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: EarthSVGpath
    });
}

const EditSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M20.71 7.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83 3.75 3.75 1.84-1.83ZM3 17.25V21h3.75L17.81 9.93l-3.75-3.75L3 17.25Z'
});
function EditIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: EditSVGpath
    });
}

const EmailSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M20 20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16Zm0-14-8 5-8-5h16ZM4 18V8.4l8 5 8-5V18H4Z'
});
function EmailIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: EmailSVGpath
    });
}

const ErrorSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13 13h-2V7h2v6Zm0 4h-2v-2h2v2ZM12 2C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Z'
});
function ErrorIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ErrorSVGpath
    });
}

const ErrorOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M11 15h2v2h-2v-2Zm0-8h2v6h-2V7Zm1-5C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z'
});
function ErrorOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ErrorOutlineSVGpath
    });
}

const ExcelFileSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Zm1.8 18H14l-2-3.4-2 3.4H8.2l2.9-4.5L8.2 11H10l2 3.4 2-3.4h1.8l-2.9 4.5 2.9 4.5ZM13 9V3.5L18.5 9H13Z'
});
function ExcelFileIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ExcelFileSVGpath
    });
}

const ExternalSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7Zm5 16H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2v7Z'
});
function ExternalIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ExternalSVGpath
    });
}

const EyeOffSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M2 5.27 3.28 4 20 20.72 18.73 22l-3.08-3.08c-1.15.38-2.37.58-3.65.58-5 0-9.27-3.11-11-7.5.69-1.76 1.79-3.31 3.19-4.54L2 5.27ZM12 9a3 3 0 0 1 2.83 4L11 9.17A3 3 0 0 1 12 9Zm0-4.5c5 0 9.27 3.11 11 7.5a11.79 11.79 0 0 1-4 5.19l-1.42-1.43A9.862 9.862 0 0 0 20.82 12 9.82 9.82 0 0 0 12 6.5c-1.09 0-2.16.18-3.16.5L7.3 5.47c1.44-.62 3.03-.97 4.7-.97ZM3.18 12A9.821 9.821 0 0 0 12 17.5c.69 0 1.37-.07 2-.21L11.72 15A3.064 3.064 0 0 1 9 12.28L5.6 8.87c-.99.85-1.82 1.91-2.42 3.13Z'
});
function EyeOffIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: EyeOffSVGpath
    });
}

const EyeOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0-4.5c5 0 9.27 3.11 11 7.5-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5ZM3.18 12a9.822 9.822 0 0 0 17.64 0 9.821 9.821 0 0 0-17.64 0Z'
});
function EyeOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: EyeOutlineSVGpath
    });
}

const FacebookSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2C6.5 2 2 6.49 2 12.02c0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.81c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9C22 6.49 17.5 2 12 2Z'
});
function FacebookIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FacebookSVGpath
    });
}

const FamilySVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15.5 10c1.63 0 3.12.35 4.5 1.05 1.34.71 2 1.56 2 2.56v7.13h-6.61V19c0-.95-.86-1.62-2.58-2.03-.56-.13-1-.19-1.31-.19-.87 0-1.7.17-2.46.52-.77.34-1.23.78-1.38 1.31 1.986.623 3.916.696 4.589.701h.185l.065-.001h.001v2.63h-.064l-.11.002h-.368c-1.3-.005-4.683-.088-7.348-.752-.33-.14-.64-.29-.91-.45-1.14-.67-1.7-1.46-1.7-2.36v-4.77c0-.87.51-1.64 1.53-2.29.15-.09.3-.18.47-.27C5.38 10.35 6.87 10 8.5 10c1.25 0 2.41.2 3.5.61a9.91 9.91 0 0 1 3.5-.61Zm-4 2c-1.1 0-2 .9-2 2 0 .75.41 1.4 1.02 1.74.29.17.62.26.98.26s.69-.09.98-.26c.61-.34 1.02-.99 1.02-1.74 0-1.1-.9-2-2-2ZM8.499 3.004a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM15.5 3c1.66 0 3 1.35 3 3 0 1.66-1.34 3-3 3s-3-1.34-3-3c0-1.65 1.34-3 3-3Z'
});
function FamilyIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FamilySVGpath
    });
}

const FavoriteSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm12 21.35-1.45-1.32C5.4 15.36 2 12.27 2 8.5 2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35Z'
});
function FavoriteIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FavoriteSVGpath
    });
}

const FavoriteOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M10.55 20.03L12 21.35L13.45 20.03C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3C15.3743 3 14.2779 3.33904 13.3488 3.92234C12.8419 4.24063 12.3848 4.63165 12 5.08C11.6152 4.63165 11.1581 4.24063 10.6512 3.92234C9.72215 3.33904 8.62572 3 7.5 3C4.42 3 2 5.41 2 8.5C2 12.27 5.4 15.36 10.55 20.03ZM12 17.97C14.5103 15.6928 16.4107 13.9479 17.7206 12.3453C19.0426 10.728 19.5 9.56311 19.5 8.5C19.5 6.79369 18.2023 5.5 16.5 5.5C15.5158 5.5 14.5297 5.97115 13.8971 6.70821L12 8.91858L10.1029 6.70821C9.47032 5.97115 8.48424 5.5 7.5 5.5C5.79773 5.5 4.5 6.79369 4.5 8.5C4.5 9.56311 4.9574 10.728 6.27941 12.3453C7.58929 13.9479 9.48974 15.6928 12 17.97Z',
    fillRule: 'evenodd',
    clipRule: 'evenodd'
});
function FavoriteOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FavoriteOutlineSVGpath
    });
}

const FileSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13 9h5.5L13 3.5V9ZM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2Zm9 16v-2H6v2h9Zm3-4v-2H6v2h12Z'
});
function FileIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FileSVGpath
    });
}

const FileOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Zm4 18H6V4h7v5h5v11Z'
});
function FileOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FileOutlineSVGpath
    });
}

const FilterSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M6 13h12v-2H6v2ZM3 6v2h18V6H3Zm7 12h4v-2h-4v2Z'
});
function FilterIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FilterSVGpath
    });
}

const FolkeregisterSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19.95,4H3.64c-.89.03-1.6.71-1.64,1.56v10.93c.03.85.74,1.53,1.63,1.56h11.22c-.05-.27-.09-.55-.09-.83,0-2.23,1.87-4.03,4.17-4.03,1,0,1.92.35,2.63.94V5.56c-.03-.85-.73-1.53-1.61-1.56ZM8.9,7.12c1.16,0,2.1.91,2.1,2.02s-.95,2.04-2.1,2.04-2.09-.92-2.09-2.04.94-2.02,2.09-2.02ZM13.09,15.23H4.71v-1.02c0-1.34,2.8-2.02,4.19-2.02s4.19.68,4.19,2.02v1.02ZM17,12.65h-3.35v-1.09h3.35v1.09ZM19.23,10.48h-5.58v-1.08h5.58v1.08ZM19.23,8.32h-5.58v-1.08h5.58v1.08ZM22,16.41l-2.39-2.27v1.3c-2.39.32-3.42,1.95-3.75,3.57.85-1.13,2.04-1.65,3.75-1.65v1.33l2.39-2.27Z'
});
function FolkeregisterIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FolkeregisterSVGpath
    });
}

const FolkeregisterOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15.7638 17.4946H15.7618L15.7638 17.4838V17.4946ZM15.7618 17.4946H4.63037V6.56587H20.9229V14.3305C21.5371 14.4924 22.0843 14.784 22.5533 15.1728V6.56587C22.5198 5.71274 21.8163 5.0324 20.9341 5H4.63037C3.73702 5.0324 3.0335 5.71274 3 6.55508V17.473C3.0335 18.3261 3.73702 19.0065 4.61921 19.0389H15.775C15.7192 18.7689 15.6857 18.4881 15.6857 18.2073C15.6857 17.9627 15.7181 17.7286 15.7618 17.4946ZM11.5092 10.0162L11.5092 10.0108C11.5092 8.96328 10.627 8.12095 9.54383 8.12095C8.46064 8.12095 7.58961 8.96328 7.58961 10.0108L7.58962 10.0162L7.58961 10.0216C7.58961 11.0691 8.46064 11.9222 9.54383 11.9222C10.627 11.9222 11.5092 11.0691 11.5092 10.0216L11.5092 10.0162ZM5.6354 15.6911H13.4523V15.6803V14.7516V14.7408C13.4523 13.4881 10.8392 12.851 9.54383 12.851C8.24846 12.851 5.6354 13.4881 5.6354 14.7408V14.7516V15.6803V15.6911ZM14.0106 8.25054H19.5941V9.06047H14.0106V8.25054ZM19.5941 10.4104H14.0106V11.2203H19.5941V10.4104ZM14.0106 12.5702H17.3607V13.3801H14.0106V12.5702ZM20.6103 16.4363V15.1404L23 17.4082L20.6103 19.676V18.3477C18.9017 18.3477 17.7069 18.8661 16.8582 20C17.1932 18.3801 18.2205 16.7603 20.6103 16.4363Z'
});
function FolkeregisterOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FolkeregisterOutlineSVGpath
    });
}

const FormatAlignLeftSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M3 3h18v2H3V3Zm0 4h12v2H3V7Zm0 4h18v2H3v-2Zm0 4h12v2H3v-2Zm0 4h18v2H3v-2Z'
});
function FormatAlignLeftIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FormatAlignLeftSVGpath
    });
}

const FormatAlignRightSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M3 3h18v2H3V3Zm6 4h12v2H9V7Zm-6 4h18v2H3v-2Zm6 4h12v2H9v-2Zm-6 4h18v2H3v-2Z'
});
function FormatAlignRightIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FormatAlignRightSVGpath
    });
}

const ForumSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M17 12V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14l4-4h10a1 1 0 0 0 1-1Zm4-6h-2v9H6v2a1 1 0 0 0 1 1h11l4 4V7a1 1 0 0 0-1-1Z'
});
function ForumIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ForumSVGpath
    });
}

const HammerSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm16 5 3 3-.5.5c1 1 1.5 1.5 2 1L22 11c0 1-1.5 2.5-2.5 2.5L18 12c.5-.5 0-1-1-2l-1 1-3-3c1.5-2 0-4-4-3 1-1 2-2 3-2 .5 0 2 0 4 2ZM2 20l2 2 10-10-2-2L2 20Z'
});
function HammerIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: HammerSVGpath
    });
}

const HelpFilledSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm15.07 11.25-.9.92C13.45 12.89 13 13.5 13 15h-2v-.5c0-1.11.45-2.11 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41a2 2 0 1 0-4 0H8a4 4 0 0 1 8 0 3.2 3.2 0 0 1-.93 2.25ZM13 19h-2v-2h2v2ZM12 2C6.477 2 2 6.477 2 12a10 10 0 0 0 20 0c0-5.53-4.5-10-10-10Z'
});
function HelpFilledIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: HelpFilledSVGpath
    });
}

const HelpOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M11 18h2v-2h-2v2Zm1-16C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14a4 4 0 0 0-4 4h2a2 2 0 1 1 4 0c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4Z'
});
function HelpOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: HelpOutlineSVGpath
    });
}

const HelpSimpleSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M10 19h3v3h-3v-3Zm2-17c5.35.22 7.68 5.62 4.5 9.67-.83 1-2.17 1.66-2.83 2.5C13 15 13 16 13 17h-3c0-1.67 0-3.08.67-4.08.66-1 2-1.59 2.83-2.25C15.92 8.43 15.32 5.26 12 5a3 3 0 0 0-3 3H6a6 6 0 0 1 6-6Z'
});
function HelpSimpleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: HelpSimpleSVGpath
    });
}

const HistorySVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13.5 8H12v5l4.28 2.54.72-1.21-3.5-2.08V8ZM13 3a9 9 0 0 0-9 9H1l3.96 4.03L9 12H6a7 7 0 1 1 7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.895 8.895 0 0 0 13 21a9 9 0 0 0 0-18Z'
});
function HistoryIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: HistorySVGpath
    });
}

const HomeSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5Z'
});
function HomeIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: HomeSVGpath
    });
}

const InfoSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13 9h-2V7h2v2Zm0 8h-2v-6h2v6ZM12 2C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Z'
});
function InfoIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: InfoSVGpath
    });
}

const InfoOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M11 9h2V7h-2v2Zm1 11c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-18C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Zm-1 15h2v-6h-2v6Z'
});
function InfoOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: InfoOutlineSVGpath
    });
}

const InfoSimpleSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M10.75 8.4h2.5V6h-2.5v2.4Zm0 9.6h2.5v-7.2h-2.5V18Z'
});
function InfoSimpleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: InfoSimpleSVGpath
    });
}

const InfoSquareSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M21 3H3v18h18zm-7.75 5.4h-2.5V6h2.5zm0 9.6h-2.5v-7.2h2.5z'
});
function InfoSquareIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: InfoSquareSVGpath
    });
}

const KeySVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12.6 10c-.8-2.3-3-4-5.6-4-3.3 0-6 2.7-6 6s2.7 6 6 6c2.6 0 4.8-1.7 5.6-4H16v4h4v-4h3v-4H12.6ZM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z'
});
function KeyIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: KeySVGpath
    });
}

const KronerSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 1.44c5.832 0 10.56 4.728 10.56 10.56 0 5.832-4.728 10.56-10.56 10.56-5.832 0-10.56-4.728-10.56-10.56C1.44 6.168 6.168 1.44 12 1.44Zm0 1.394a9.166 9.166 0 1 0 0 18.332 9.166 9.166 0 0 0 0-18.332ZM8.649 9.6v1.814L10.168 9.6h1.925l-1.708 1.81 1.785 2.99h-1.785l-.988-1.974-.748.802V14.4H7.2V9.6h1.449Zm6.434 0c.448 0 .79.04 1.027.118.236.078.427.224.572.437.145.213.217.472.217.778 0 .266-.055.496-.166.689a1.31 1.31 0 0 1-.457.47c-.124.076-.293.14-.509.19.173.059.299.117.378.176.053.04.13.124.232.253.1.128.169.228.203.297l.7 1.392h-1.637l-.774-1.467c-.098-.19-.186-.313-.263-.37a.598.598 0 0 0-.354-.111h-.128V14.4h-1.455V9.6h2.414Zm-.323.97h-.636v.975h.61c.067 0 .194-.022.384-.066a.382.382 0 0 0 .235-.15.45.45 0 0 0 .091-.279c0-.155-.048-.273-.144-.356-.095-.083-.276-.125-.54-.125v.001Z'
});
function KronerIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: KronerSVGpath
    });
}

const LanPendingSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M4 1c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2H1v2h12V9h-3c1.11 0 2-.89 2-2V3c0-1.11-.89-2-2-2H4Zm0 2h6v4H4V3Zm-1 9v2h2v-2H3Zm11 1c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h-3v2h12v-2h-3c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2h-6ZM3 15v2h2v-2H3Zm11 0h6v4h-6v-4ZM3 18v2h2v-2H3Zm3 0v2h2v-2H6Zm3 0v2h2v-2H9Z'
});
function LanPendingIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: LanPendingSVGpath
    });
}

const LinkedinSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14Zm-.5 15.5v-5.3c0-1.8-1.46-3.26-3.26-3.26-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79ZM6.88 8.56a1.686 1.686 0 0 0 0-3.37 1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68Zm1.39 9.94v-8.37H5.5v8.37h2.77Z'
});
function LinkedinIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: LinkedinSVGpath
    });
}

const ListAddSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M20 6H4v2h16V6Zm-9 5H4v2h7v-2Zm-7 5h7v2H4v-2Zm12-2h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3Z'
});
function ListAddIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ListAddSVGpath
    });
}

const ListRemoveSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M4 6h16v2H4V6Zm0 5h7v2H4v-2Zm7 5H4v2h7v-2Zm10-2.5v2h-8v-2h8ZM17 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z'
});
function ListRemoveIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ListRemoveSVGpath
    });
}

const ListReorderSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18.5 6h-16v2h16V6Zm3 5h-16v2h16v-2Zm-19 5h16v2h-16v-2Z'
});
function ListReorderIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ListReorderSVGpath
    });
}

const LockSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 1 1 10 0v2h1Zm-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3Z'
});
function LockIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: LockSVGpath
    });
}

const LockOpenSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18 8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h9V6a3 3 0 0 0-6 0H7a5 5 0 1 1 10 0v2h1Zm-6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'
});
function LockOpenIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: LockOpenSVGpath
    });
}

const LockOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 17a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 0 4Zm6 3V10H6v10h12Zm0-12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10c0-1.11.89-2 2-2h1V6a5 5 0 1 1 10 0v2h1Zm-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3Z'
});
function LockOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: LockOutlineSVGpath
    });
}

const LockOutlineOpenSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18 20V10H6v10h12Zm0-12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h9V6a3 3 0 0 0-6 0H7a5 5 0 1 1 10 0v2h1Zm-6 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z'
});
function LockOutlineOpenIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: LockOutlineOpenSVGpath
    });
}

const LogOutSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M14.08 15.59L16.67 13H7V11H16.67L14.08 8.41L15.5 7L20.5 12L15.5 17L14.08 15.59ZM19 3C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V9.67L19 7.67V5H5V19H19V16.33L21 14.33V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.89 3.89 3 5 3H19Z'
});
function LogOutIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: LogOutSVGpath
    });
}

const MarriageSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18.1 5.5c1.7 1 2.9 2.9 2.9 5.1 0 3.2-2.6 5.9-5.9 5.9-3.3 0-6-2.7-6-6v-.7c-2.4.3-4.2 2.3-4.2 4.7 0 2.7 2.2 4.8 4.8 4.8 1.6 0 3-.8 3.9-2 .5.1 1 .2 1.5.2h.8c-1.1 2.3-3.4 3.9-6.1 3.9-3.8 0-6.8-3-6.8-6.8s3-6.8 6.7-6.8h.1c.5-1 1.3-1.8 2.3-2.2l1.4 1.5c-.6.3-1.1.7-1.5 1.2 2.5.8 4.4 3.2 4.5 6 1.5-.6 2.5-2 2.5-3.7 0-1.6-1-3-2.3-3.6l1.4-1.5Zm-7 4.5v.5c0 2 1.5 3.6 3.4 3.9-.1-2-1.4-3.7-3.4-4.4Zm5.5-7 .7 1.3-2.2 2.8-2.3-2.8.8-1.3h3Z'
});
function MarriageIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MarriageSVGpath
    });
}

const MenuSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M3 6h18v2H3V6Zm0 5h18v2H3v-2Zm0 5h18v2H3v-2Z'
});
function MenuIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MenuSVGpath
    });
}

const MenuDownSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm7 10 5 5 5-5H7Z'
});
function MenuDownIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MenuDownSVGpath
    });
}

const MenuUpSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm7 15 5-5 5 5H7Z'
});
function MenuUpIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MenuUpSVGpath
    });
}

const MinusSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19 11H5V13.5H19V11Z'
});
function MinusIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MinusSVGpath
    });
}

const MoreSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-4.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z'
});
function MoreIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MoreSVGpath
    });
}

const MoveUpSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M11.1 17.6h1.8v1.1h-1.8v-1.1zm0-3.3h1.8v2.2h-1.8v-2.2zm0 6.2h1.8v.5h-1.8v-.5zm-4.9-7.3 5-5v5.1H13V8.2l5 4.9 1.3-1.3-7.3-7-7.1 7.1 1.3 1.3zM21 3H3v1.8h18V3z'
});
function MoveUpIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MoveUpSVGpath
    });
}

const PDFFileSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13 9h5.5L13 3.5V9ZM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm4.1 9.4c-.02.04-.29 1.76-2.1 4.69 0 0-3.5 1.82-2.67 3.18.67 1.08 2.32-.04 3.74-2.68 0 0 1.82-.64 4.24-.82 0 0 3.86 1.73 4.39-.11.52-1.86-3.06-1.44-3.7-1.25 0 0-2-1.35-2.5-3.21 0 0 1.14-3.95-.61-3.9-1.75.05-1.09 3.13-.79 4.1Zm.81 1.04c.03.01.47 1.21 1.89 2.46 0 0-2.33.46-3.39.9 0 0 1-1.73 1.5-3.36Zm3.93 2.72c.58-.16 2.33.15 2.26.48-.06.33-2.26-.48-2.26-.48ZM7.77 17c-.53 1.24-1.44 2-1.67 2-.23 0 .7-1.6 1.67-2Zm3.14-6.93c0-.07-.36-2.2 0-2.15.54.08 0 2.08 0 2.15Z'
});
function PDFFileIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PDFFileSVGpath
    });
}

const PauseOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13 16V8h2v8h-2Zm-4 0V8h2v8H9Zm3-14a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10a10 10 0 0 1 0-20Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z'
});
function PauseOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PauseOutlineSVGpath
    });
}

const PencilOffSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18.66 2c-.26 0-.5.09-.69.28l-1.84 1.85 3.75 3.75 1.84-1.85c.39-.39.39-1.03 0-1.4l-2.34-2.35c-.2-.19-.47-.28-.72-.28ZM3.28 4 2 5.28l6.5 6.47-4.5 4.5V20h3.75l4.5-4.5 6.47 6.5L20 20.72l-6.5-6.47-3.75-3.75L3.28 4Zm11.78 1.19-4.03 4.03 3.75 3.75 4.03-4.03-3.75-3.75Z'
});
function PencilOffIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PencilOffSVGpath
    });
}

const PercentSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M7.662 10.095c.384 0 .711-.135.982-.406.27-.27.406-.598.406-.982 0-.383-.135-.71-.406-.981a1.337 1.337 0 0 0-.982-.406c-.384 0-.711.135-.982.406-.27.27-.405.598-.405.981 0 .384.135.712.405.982.271.27.598.406.982.406Zm3.247-1.388a3.14 3.14 0 0 1-.947 2.296 3.123 3.123 0 0 1-2.3.95 3.127 3.127 0 0 1-2.295-.95 3.128 3.128 0 0 1-.951-2.296c0-.895.317-1.66.951-2.295a3.128 3.128 0 0 1 2.295-.95c.896 0 1.661.316 2.295.95.635.634.952 1.4.952 2.295Zm6.623 6.354c0-.384-.135-.712-.405-.982a1.336 1.336 0 0 0-.982-.406c-.384 0-.712.135-.982.406a1.34 1.34 0 0 0-.406.982c0 .384.135.71.406.981.27.271.598.406.982.406s.711-.135.982-.406c.27-.27.405-.597.405-.981Zm1.86 0a3.13 3.13 0 0 1-.952 2.295c-.634.634-1.4.951-2.295.951a3.127 3.127 0 0 1-2.295-.951 3.128 3.128 0 0 1-.952-2.295c0-.902.317-1.669.952-2.3a3.135 3.135 0 0 1 2.295-.947c.896 0 1.66.317 2.295.951.634.635.951 1.4.951 2.296h.001ZM14.756 5.4h1.327L9.032 18.386H7.68L14.757 5.4h-.001Z'
});
function PercentIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PercentSVGpath
    });
}

const PercentCompanySVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M5.925 3.175v8.875L10.45 8.3c.175-.15.425-.025.425.2v3.55L15.4 8.3c.175-.15.425-.025.425.2v3.55h.05L20.4 8.3c.175-.125.425-.025.425.2v12.375h-17.7v-17.7h2.8Zm8.225 12.75c-1 0-1.725.75-1.725 1.875s.75 1.875 1.725 1.875c1 0 1.725-.75 1.725-1.875 0-1.15-.7-1.875-1.725-1.875Zm-.025-2.825h-.875L9.8 19.525h.875l3.45-6.425Zm.025 3.6c.375 0 .575.475.575 1.075 0 .625-.175 1.075-.575 1.075-.425 0-.575-.45-.575-1.075s.175-1.075.575-1.075Zm-4.325-3.75c-1 0-1.725.725-1.725 1.875S8.825 16.7 9.825 16.7s1.725-.75 1.725-1.875-.7-1.875-1.725-1.875Zm-.025.775c.4 0 .575.475.575 1.1 0 .65-.175 1.075-.575 1.05-.4 0-.575-.425-.575-1.05 0-.65.175-1.1.575-1.1Z'
});
function PercentCompanyIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PercentCompanySVGpath
    });
}

const PersonSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4Z'
});
function PersonIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PersonSVGpath
    });
}

const PersonMoreSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4Zm-9-4V7H4v3H1v2h3v3h2v-3h3v-2H6Zm9 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'
});
function PersonMoreIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PersonMoreSVGpath
    });
}

const PersonMoreOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 1.9a2.1 2.1 0 1 1 0 4.199A2.1 2.1 0 0 1 15 5.9ZM4 7v3H1v2h3v3h2v-3h3v-2H6V7H4Zm11 6c-2.67 0-8 1.33-8 4v3h16v-3c0-2.67-5.33-4-8-4Zm0 1.9c2.97 0 6.1 1.46 6.1 2.1v1.1H8.9V17c0-.64 3.1-2.1 6.1-2.1Z'
});
function PersonMoreOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PersonMoreOutlineSVGpath
    });
}

const PersonOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 7c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4Zm0 1.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1Z'
});
function PersonOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PersonOutlineSVGpath
    });
}

const PhoneSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 3C7.46 3 3.34 4.78.29 7.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48a1.01 1.01 0 0 0 1.41.01c.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1C8.85 5.25 10.39 5 12 5c1.59 0 3.14.25 4.59.72v3.1c0 .39.23.74.56.9.98.49 1.85 1.12 2.67 1.85.18.18.43.28.68.28.3 0 .55-.11.73-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7A16.965 16.965 0 0 0 12 3ZM9 7v3s-6 5-6 8v4h18v-4c0-3-6-8-6-8V7h-2v2h-2V7H9Zm3 5a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z'
});
function PhoneIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PhoneSVGpath
    });
}

const PinSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M7 2v2h1v8l-2 2v1.999h5.2V22h1.601v-6.001H18V14l-2-2V4h1V2H7Z'
});
function PinIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PinSVGpath
    });
}

const PinoffSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M8 2v2h1v2.18l9.82 9.819H19V14l-2-2V4h1V2H8ZM3 5.27l6 6V12l-2.001 2v1.999h5.2V22H13.8v-5.93L19.73 22 21 20.72 4.279 4 3 5.27Z'
});
function PinoffIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PinoffSVGpath
    });
}

const PlayOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-18C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Zm-2 14.5 6-4.5-6-4.5v9Z'
});
function PlayOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PlayOutlineSVGpath
    });
}

const PreviewFileSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm14 2 6 6v12.1c0 .7-.3 1.2-.8 1.6l-1.6-1.6-2.8-2.9c-.9.5-1.8.8-2.8.8-1.3 0-2.5-.5-3.5-1.5-2-1.9-2-5.1 0-7C9.4 8.5 10.7 8 12 8c1.3 0 2.5.5 3.5 1.5 1.8 1.7 2 4.4.7 6.3l1.8 1.8V9l-5-5H6v16h8.8l2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8Zm-2 8c-.8 0-1.5.3-2.1.9-.6.5-.9 1.3-.9 2.1s.3 1.5.9 2.1c.5.6 1.3.9 2.1.9s1.5-.3 2.1-.9c.6-.6.9-1.3.9-2.1s-.3-1.5-.9-2.1c-.6-.6-1.3-.9-2.1-.9Z'
});
function PreviewFileIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PreviewFileSVGpath
    });
}

const PrintSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18 3H6v4h12V3Zm1 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-3 7H8v-5h8v5Zm3-11H5a3 3 0 0 0-3 3v6h4v4h12v-4h4v-6a3 3 0 0 0-3-3Z'
});
function PrintIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PrintSVGpath
    });
}

const SaveSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15 9H5V5h10v4Zm-3 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm5-16H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4Z'
});
function SaveIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SaveSVGpath
    });
}

const SearchSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5-1.5 1.5-5-5v-.79l-.27-.27A6.516 6.516 0 0 1 9.5 16a6.5 6.5 0 1 1 0-13Zm0 2C7 5 5 7 5 9.5S7 14 9.5 14 14 12 14 9.5 12 5 9.5 5Z'
});
function SearchIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SearchSVGpath
    });
}

const SendSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M2 3v7l15 2-15 2v7l21-9L2 3Z'
});
function SendIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SendSVGpath
    });
}

const SettingsSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 15.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm7.43-2.53c.04-.32.07-.64.07-.97 0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1 0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66Z'
});
function SettingsIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SettingsSVGpath
    });
}

const ShareSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11a2.987 2.987 0 0 0 3.707.304A3 3 0 1 0 15 5c0 .24.04.47.09.7L8.04 9.81a2.987 2.987 0 0 0-4.161.069A3 3 0 0 0 6 15c.79 0 1.5-.31 2.04-.81l7.12 4.15c-.05.21-.08.43-.08.66 0 1.61 1.31 2.91 2.92 2.91a2.915 2.915 0 1 0 0-5.83Z'
});
function ShareIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ShareSVGpath
    });
}

const SkattetrekkSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M11.52 4.656a7.61 7.61 0 0 1 1.682.18l-2.788 9.301 8.614-3.568c.15.61.223 1.235.22 1.863a7.723 7.723 0 0 1-7.728 7.728c-4.272 0-7.776-3.456-7.776-7.728S7.2 4.656 11.52 4.656Zm4.058-.789-.074-.027c2.01.7 3.623 2.234 4.475 4.17l-6.442 2.669 2.041-6.812Z'
});
function SkattetrekkIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SkattetrekkSVGpath
    });
}

const SoeknadSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M10 17c0 1.1.9 2 2 2s2-.9 2-2h7v2c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-2h7Zm9-14c1.1 0 2 .9 2 2v10H3V5a2 2 0 0 1 2-2h14Zm0 2H5v5h5c0 .36.1.71.27 1a1.996 1.996 0 0 0 3.46 0c.17-.29.27-.64.27-1h5V5Z'
});
function SoeknadIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SoeknadSVGpath
    });
}

const SortAscSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M17 3v14h-3.001L18 21l3.999-4H19V3h-2ZM2 7h4V5H2v2Zm0 6h7v-2H2v2Zm0 6h10v-2H2v2Z'
});
function SortAscIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SortAscSVGpath
    });
}

const SortDefaultSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm18 3-4.001 4H17v10h-3.001L18 21l4-4h-3V7h3l-4-4ZM2 7h4V5H2v2Zm0 6h7v-2H2v2Zm0 6h10v-2H2v2Z'
});
function SortDefaultIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SortDefaultSVGpath
    });
}

const SortDescSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm18 3-4.001 4H17v14h2V7h3l-4-4ZM2 7h4V5H2v2Zm0 6h7v-2H2v2Zm0 6h10v-2H2v2Z'
});
function SortDescIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SortDescSVGpath
    });
}

const TimelapseSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm0-18C6.477 2 2 6.477 2 12A10 10 0 1 0 12 2Zm4.24 5.76A5.95 5.95 0 0 0 12 6v6l-4.24 4.24a6 6 0 0 0 8.48 0 5.982 5.982 0 0 0 0-8.48Z'
});
function TimelapseIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: TimelapseSVGpath
    });
}

const TimelineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm16 11.78 4.24-7.33 1.73 1-5.23 9.05-6.51-3.75L5.46 19H22v2H2V3h2v14.54L9.5 8l6.5 3.78Z'
});
function TimelineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: TimelineSVGpath
    });
}

const TimersandSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M6 2h12v6l-4 4 4 4v6H6v-6l4-4-4-4V2Zm10 14.5-4-4-4 4V20h8v-3.5Zm-4-5 4-4V4H8v3.5l4 4ZM10 6h4v.75l-2 2-2-2V6Z'
});
function TimersandIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: TimersandSVGpath
    });
}

const TwitterSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23Z'
});
function TwitterIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: TwitterSVGpath
    });
}

const UndoSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12.233 8.9C9.90278 8.9 7.79238 9.8 6.16561 11.24L3 8V16.1H10.914L7.73083 12.842C8.9531 11.798 10.5095 11.15 12.233 11.15C15.3459 11.15 17.9927 13.229 18.916 16.1L21 15.398C19.7777 11.627 16.3219 8.9 12.233 8.9Z'
});
function UndoIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: UndoSVGpath
    });
}

const UpdateSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M19.35,11.76c-.06-2.09-.92-4.11-2.39-5.59-1.54-1.56-3.59-2.42-5.77-2.42s-4.24.86-5.8,2.43c-1.54,1.56-2.4,3.63-2.4,5.83,0,2.2.85,4.27,2.39,5.83,1.54,1.56,3.6,2.41,5.78,2.41,1.46,0,2.89-.4,4.15-1.14l.28-.16-1.81-1.82-.16.08c-.77.37-1.6.56-2.45.56-1.52,0-2.95-.6-4.03-1.68-2.22-2.24-2.22-5.9,0-8.14,1.08-1.08,2.51-1.68,4.03-1.68s2.95.6,4.03,1.68c1.01,1.01,1.61,2.39,1.64,3.83h-4.86l5.51,5.56,5.51-5.56h-3.65Z'
});
function UpdateIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: UpdateSVGpath
    });
}

const UploadSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M9 16v-6H5l7-7 7 7h-4v6H9Zm-4 4v-2h14v2H5Z'
});
function UploadIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: UploadSVGpath
    });
}

const VerticalDotsSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M16 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z'
});
function VerticalDotsIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: VerticalDotsSVGpath
    });
}

const VerticalDotsCircleSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10a10 10 0 0 1 0-20Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-4.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z'
});
function VerticalDotsCircleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: VerticalDotsCircleSVGpath
    });
}

const VerticalDotsCircleSolidSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10a10 10 0 0 1 0-20Zm0 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-5.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z'
});
function VerticalDotsCircleSolidIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: VerticalDotsCircleSolidSVGpath
    });
}

/**
 * @deprecated komponenten har en skrivefeil i navnet og erstattes av WarningOutlineSVGpath. Fjernes i neste major release.
 */ const WaringOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2 1 21h22L12 2Zm0 4 7.53 13H4.47L12 6Zm-1 4v4h2v-4h-2Zm0 6v2h2v-2'
});
// eslint-disable-next-line jsdoc/require-returns, jsdoc/require-param
/**
 * @deprecated komponenten har en skrivefeil i navnet og erstattes av WarningOutlineIcon. Fjernes i neste major release.
 */ function WaringOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: WaringOutlineSVGpath
    });
}

const WarningSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13 14h-2v-4h2v4Zm0 4h-2v-2h2v2ZM1 21h22L12 2 1 21Z'
});
function WarningIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: WarningSVGpath
    });
}

const WarningOutlineSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12 2 1 21h22L12 2Zm0 4 7.53 13H4.47L12 6Zm-1 4v4h2v-4h-2Zm0 6v2h2v-2'
});
function WarningOutlineIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: WarningOutlineSVGpath
    });
}

const WarningStopSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM13 16h-2v-2h2zm0-4h-2V8h2z'
});
function WarningStopIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: WarningStopSVGpath
    });
}

const WordFileSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Zm1.2 18h-1.4L12 13.2 10.2 20H8.8l-2.2-9h1.5l1.4 6.8 1.8-6.8h1.3l1.8 6.8 1.4-6.8h1.5l-2.1 9ZM13 9V3.5L18.5 9H13Z'
});
function WordFileIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: WordFileSVGpath
    });
}

const XMLFileSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13 9h5.5L13 3.5V9ZM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2Zm.12 13.5 3.74 3.74 1.42-1.41-2.33-2.33 2.33-2.33-1.42-1.41-3.74 3.74Zm11.16 0-3.74-3.74-1.42 1.41 2.33 2.33-2.33 2.33 1.42 1.41 3.74-3.74Z'
});
function XMLFileIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: XMLFileSVGpath
    });
}

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AccountArrowBackIcon: AccountArrowBackIcon,
  AccountArrowBackSVGpath: AccountArrowBackSVGpath,
  AccountBoxIcon: AccountBoxIcon,
  AccountBoxSVGpath: AccountBoxSVGpath,
  AccountChildIcon: AccountChildIcon,
  AccountChildSVGpath: AccountChildSVGpath,
  AccountEnkIcon: AccountEnkIcon,
  AccountEnkSVGpath: AccountEnkSVGpath,
  AccountMultipleIcon: AccountMultipleIcon,
  AccountMultipleSVGpath: AccountMultipleSVGpath,
  AddIcon: AddIcon,
  AddOutlineIcon: AddOutlineIcon,
  AddOutlineSVGpath: AddOutlineSVGpath,
  AddSVGpath: AddSVGpath,
  ArchiveIcon: ArchiveIcon,
  ArchiveOutlineIcon: ArchiveOutlineIcon,
  ArchiveOutlineSVGpath: ArchiveOutlineSVGpath,
  ArchiveSVGpath: ArchiveSVGpath,
  ArrowBackIcon: ArrowBackIcon,
  ArrowBackSVGpath: ArrowBackSVGpath,
  ArrowDownIcon: ArrowDownIcon,
  ArrowDownSVGpath: ArrowDownSVGpath,
  ArrowForwardIcon: ArrowForwardIcon,
  ArrowForwardSVGpath: ArrowForwardSVGpath,
  ArrowUpDownIcon: ArrowUpDownIcon,
  ArrowUpDownSVGpath: ArrowUpDownSVGpath,
  ArrowUpIcon: ArrowUpIcon,
  ArrowUpSVGpath: ArrowUpSVGpath,
  AttachFileIcon: AttachFileIcon,
  AttachFileSVGpath: AttachFileSVGpath,
  BellIcon: BellIcon,
  BellOutlineIcon: BellOutlineIcon,
  BellOutlineSVGpath: BellOutlineSVGpath,
  BellSVGpath: BellSVGpath,
  BlockedIcon: BlockedIcon,
  BlockedSVGpath: BlockedSVGpath,
  BookOpenIcon: BookOpenIcon,
  BookOpenOutlineIcon: BookOpenOutlineIcon,
  BookOpenOutlineSVGpath: BookOpenOutlineSVGpath,
  BookOpenSVGpath: BookOpenSVGpath,
  BookmarOutlinekIcon: BookmarOutlinekIcon,
  BookmarkIcon: BookmarkIcon,
  BookmarkOutlineSVGpath: BookmarkOutlineSVGpath,
  BookmarkSVGpath: BookmarkSVGpath,
  BriefcaseIcon: BriefcaseIcon,
  BriefcaseMultipleIcon: BriefcaseMultipleIcon,
  BriefcaseMultipleSVGpath: BriefcaseMultipleSVGpath,
  BriefcaseOffIcon: BriefcaseOffIcon,
  BriefcaseOffSVGpath: BriefcaseOffSVGpath,
  BriefcaseSVGpath: BriefcaseSVGpath,
  CalculatorIcon: CalculatorIcon,
  CalculatorSVGpath: CalculatorSVGpath,
  CalendarClockIcon: CalendarClockIcon,
  CalendarClockSVGpath: CalendarClockSVGpath,
  CalendarIcon: CalendarIcon,
  CalendarSVGpath: CalendarSVGpath,
  CancelIcon: CancelIcon,
  CancelSVGpath: CancelSVGpath,
  CashRefundIcon: CashRefundIcon,
  CashRefundSVGpath: CashRefundSVGpath,
  ChatBubbleIcon: ChatBubbleIcon,
  ChatBubbleOutlineIcon: ChatBubbleOutlineIcon,
  ChatBubbleOutlineSVGpath: ChatBubbleOutlineSVGpath,
  ChatBubbleSVGpath: ChatBubbleSVGpath,
  ChatbotIcon: ChatbotIcon,
  ChatbotSVGpath: ChatbotSVGpath,
  CheckIcon: CheckIcon,
  CheckSVGpath: CheckSVGpath,
  ChevronDownDoubleIcon: ChevronDownDoubleIcon,
  ChevronDownDoubleSVGpath: ChevronDownDoubleSVGpath,
  ChevronDownIcon: ChevronDownIcon,
  ChevronDownSVGpath: ChevronDownSVGpath,
  ChevronLeftDoubleIcon: ChevronLeftDoubleIcon,
  ChevronLeftDoubleSVGpath: ChevronLeftDoubleSVGpath,
  ChevronLeftIcon: ChevronLeftIcon,
  ChevronLeftSVGpath: ChevronLeftSVGpath,
  ChevronRightDoubleIcon: ChevronRightDoubleIcon,
  ChevronRightDoubleSVGpath: ChevronRightDoubleSVGpath,
  ChevronRightIcon: ChevronRightIcon,
  ChevronRightSVGpath: ChevronRightSVGpath,
  ChevronUpDoubleIcon: ChevronUpDoubleIcon,
  ChevronUpDoubleSVGpath: ChevronUpDoubleSVGpath,
  ChevronUpIcon: ChevronUpIcon,
  ChevronUpSVGpath: ChevronUpSVGpath,
  CircleDownIcon: CircleDownIcon,
  CircleDownSVGpath: CircleDownSVGpath,
  CircleFilledIcon: CircleFilledIcon,
  CircleFilledSVGpath: CircleFilledSVGpath,
  CircleRingIcon: CircleRingIcon,
  CircleRingSVGpath: CircleRingSVGpath,
  CircleUpIcon: CircleUpIcon,
  CircleUpSVGpath: CircleUpSVGpath,
  ClockIcon: ClockIcon,
  ClockOutlineIcon: ClockOutlineIcon,
  ClockOutlineSVGpath: ClockOutlineSVGpath,
  ClockSVGpath: ClockSVGpath,
  CloudIcon: CloudIcon,
  CloudSVGpath: CloudSVGpath,
  CloudUploadIcon: CloudUploadIcon,
  CloudUploadSVGpath: CloudUploadSVGpath,
  CodeIcon: CodeIcon,
  CodeSVGpath: CodeSVGpath,
  CompanyGroupIcon: CompanyGroupIcon,
  CompanyGroupSVGpath: CompanyGroupSVGpath,
  CompanyIcon: CompanyIcon,
  CompanySVGpath: CompanySVGpath,
  CompletedIcon: CompletedIcon,
  CompletedSVGpath: CompletedSVGpath,
  CopyIcon: CopyIcon,
  CopySVGpath: CopySVGpath,
  DeleteIcon: DeleteIcon,
  DeleteSVGpath: DeleteSVGpath,
  DeployIcon: DeployIcon,
  DeploySVGpath: DeploySVGpath,
  DescriptionIcon: DescriptionIcon,
  DescriptionSVGpath: DescriptionSVGpath,
  DownIcon: ArrowDownIcon,
  DownSVGpath: ArrowDownSVGpath,
  DownloadIcon: DownloadIcon,
  DownloadSVGpath: DownloadSVGpath,
  DuplicateIcon: DuplicateIcon,
  DuplicateSVGpath: DuplicateSVGpath,
  EarthIcon: EarthIcon,
  EarthSVGpath: EarthSVGpath,
  EditIcon: EditIcon,
  EditSVGpath: EditSVGpath,
  EmailIcon: EmailIcon,
  EmailSVGpath: EmailSVGpath,
  ErrorIcon: ErrorIcon,
  ErrorOutlineIcon: ErrorOutlineIcon,
  ErrorOutlineSVGpath: ErrorOutlineSVGpath,
  ErrorSVGpath: ErrorSVGpath,
  ExcelFileIcon: ExcelFileIcon,
  ExcelFileSVGpath: ExcelFileSVGpath,
  ExternalIcon: ExternalIcon,
  ExternalSVGpath: ExternalSVGpath,
  EyeOffIcon: EyeOffIcon,
  EyeOffSVGpath: EyeOffSVGpath,
  EyeOutlineIcon: EyeOutlineIcon,
  EyeOutlineSVGpath: EyeOutlineSVGpath,
  FacebookIcon: FacebookIcon,
  FacebookSVGpath: FacebookSVGpath,
  FamilyIcon: FamilyIcon,
  FamilySVGpath: FamilySVGpath,
  FavoriteIcon: FavoriteIcon,
  FavoriteOutlineIcon: FavoriteOutlineIcon,
  FavoriteOutlineSVGpath: FavoriteOutlineSVGpath,
  FavoriteSVGpath: FavoriteSVGpath,
  FileIcon: FileIcon,
  FileOutlineIcon: FileOutlineIcon,
  FileOutlineSVGpath: FileOutlineSVGpath,
  FileSVGpath: FileSVGpath,
  FilterIcon: FilterIcon,
  FilterSVGpath: FilterSVGpath,
  FolkeregisterIcon: FolkeregisterIcon,
  FolkeregisterOutlineIcon: FolkeregisterOutlineIcon,
  FolkeregisterOutlineSVGpath: FolkeregisterOutlineSVGpath,
  FolkeregisterSVGpath: FolkeregisterSVGpath,
  FormatAlignLeftIcon: FormatAlignLeftIcon,
  FormatAlignLeftSVGpath: FormatAlignLeftSVGpath,
  FormatAlignRightIcon: FormatAlignRightIcon,
  FormatAlignRightSVGpath: FormatAlignRightSVGpath,
  ForumIcon: ForumIcon,
  ForumSVGpath: ForumSVGpath,
  HammerIcon: HammerIcon,
  HammerSVGpath: HammerSVGpath,
  HelpFilledIcon: HelpFilledIcon,
  HelpFilledSVGpath: HelpFilledSVGpath,
  HelpOutlineIcon: HelpOutlineIcon,
  HelpOutlineSVGpath: HelpOutlineSVGpath,
  HelpSimpleIcon: HelpSimpleIcon,
  HelpSimpleSVGpath: HelpSimpleSVGpath,
  HistoryIcon: HistoryIcon,
  HistorySVGpath: HistorySVGpath,
  HomeIcon: HomeIcon,
  HomeSVGpath: HomeSVGpath,
  InfoIcon: InfoIcon,
  InfoOutlineIcon: InfoOutlineIcon,
  InfoOutlineSVGpath: InfoOutlineSVGpath,
  InfoSVGpath: InfoSVGpath,
  InfoSimpleIcon: InfoSimpleIcon,
  InfoSimpleSVGpath: InfoSimpleSVGpath,
  InfoSquareIcon: InfoSquareIcon,
  InfoSquareSVGpath: InfoSquareSVGpath,
  KeyIcon: KeyIcon,
  KeySVGpath: KeySVGpath,
  KronerIcon: KronerIcon,
  KronerSVGpath: KronerSVGpath,
  LanPendingIcon: LanPendingIcon,
  LanPendingSVGpath: LanPendingSVGpath,
  LinkedinIcon: LinkedinIcon,
  LinkedinSVGpath: LinkedinSVGpath,
  ListAddIcon: ListAddIcon,
  ListAddSVGpath: ListAddSVGpath,
  ListRemoveIcon: ListRemoveIcon,
  ListRemoveSVGpath: ListRemoveSVGpath,
  ListReorderIcon: ListReorderIcon,
  ListReorderSVGpath: ListReorderSVGpath,
  LockIcon: LockIcon,
  LockOpenIcon: LockOpenIcon,
  LockOpenSVGpath: LockOpenSVGpath,
  LockOutlineIcon: LockOutlineIcon,
  LockOutlineOpenIcon: LockOutlineOpenIcon,
  LockOutlineOpenSVGpath: LockOutlineOpenSVGpath,
  LockOutlineSVGpath: LockOutlineSVGpath,
  LockSVGpath: LockSVGpath,
  LogOutIcon: LogOutIcon,
  LogOutSVGpath: LogOutSVGpath,
  MarriageIcon: MarriageIcon,
  MarriageSVGpath: MarriageSVGpath,
  MenuDownIcon: MenuDownIcon,
  MenuDownSVGpath: MenuDownSVGpath,
  MenuIcon: MenuIcon,
  MenuSVGpath: MenuSVGpath,
  MenuUpIcon: MenuUpIcon,
  MenuUpSVGpath: MenuUpSVGpath,
  MinusIcon: MinusIcon,
  MinusSVGpath: MinusSVGpath,
  MoreIcon: MoreIcon,
  MoreSVGpath: MoreSVGpath,
  MoveUpIcon: MoveUpIcon,
  MoveUpSVGpath: MoveUpSVGpath,
  PDFFileIcon: PDFFileIcon,
  PDFFileSVGpath: PDFFileSVGpath,
  PauseOutlineIcon: PauseOutlineIcon,
  PauseOutlineSVGpath: PauseOutlineSVGpath,
  PencilOffIcon: PencilOffIcon,
  PencilOffSVGpath: PencilOffSVGpath,
  PercentCompanyIcon: PercentCompanyIcon,
  PercentCompanySVGpath: PercentCompanySVGpath,
  PercentIcon: PercentIcon,
  PercentSVGpath: PercentSVGpath,
  PersonIcon: PersonIcon,
  PersonMoreIcon: PersonMoreIcon,
  PersonMoreOutlineIcon: PersonMoreOutlineIcon,
  PersonMoreOutlineSVGpath: PersonMoreOutlineSVGpath,
  PersonMoreSVGpath: PersonMoreSVGpath,
  PersonOutlineIcon: PersonOutlineIcon,
  PersonOutlineSVGpath: PersonOutlineSVGpath,
  PersonSVGpath: PersonSVGpath,
  PhoneIcon: PhoneIcon,
  PhoneSVGpath: PhoneSVGpath,
  PinIcon: PinIcon,
  PinSVGpath: PinSVGpath,
  PinoffIcon: PinoffIcon,
  PinoffSVGpath: PinoffSVGpath,
  PlayOutlineIcon: PlayOutlineIcon,
  PlayOutlineSVGpath: PlayOutlineSVGpath,
  PreviewFileIcon: PreviewFileIcon,
  PreviewFileSVGpath: PreviewFileSVGpath,
  PrintIcon: PrintIcon,
  PrintSVGpath: PrintSVGpath,
  SaveIcon: SaveIcon,
  SaveSVGpath: SaveSVGpath,
  SearchIcon: SearchIcon,
  SearchSVGpath: SearchSVGpath,
  SendIcon: SendIcon,
  SendSVGpath: SendSVGpath,
  SettingsIcon: SettingsIcon,
  SettingsSVGpath: SettingsSVGpath,
  ShareIcon: ShareIcon,
  ShareSVGpath: ShareSVGpath,
  SkattetrekkIcon: SkattetrekkIcon,
  SkattetrekkSVGpath: SkattetrekkSVGpath,
  SoeknadIcon: SoeknadIcon,
  SoeknadSVGpath: SoeknadSVGpath,
  SortAscIcon: SortAscIcon,
  SortAscSVGpath: SortAscSVGpath,
  SortDefaultIcon: SortDefaultIcon,
  SortDefaultSVGpath: SortDefaultSVGpath,
  SortDescIcon: SortDescIcon,
  SortDescSVGpath: SortDescSVGpath,
  SortDownIcon: ArrowDownIcon,
  SortDownSVGpath: ArrowDownSVGpath,
  SortUpIcon: ArrowUpIcon,
  SortUpSVGpath: ArrowUpSVGpath,
  TimelapseIcon: TimelapseIcon,
  TimelapseSVGpath: TimelapseSVGpath,
  TimelineIcon: TimelineIcon,
  TimelineSVGpath: TimelineSVGpath,
  TimersandIcon: TimersandIcon,
  TimersandSVGpath: TimersandSVGpath,
  TwitterIcon: TwitterIcon,
  TwitterSVGpath: TwitterSVGpath,
  UndoIcon: UndoIcon,
  UndoSVGpath: UndoSVGpath,
  UpIcon: ArrowUpIcon,
  UpSVGpath: ArrowUpSVGpath,
  UpdateIcon: UpdateIcon,
  UpdateSVGpath: UpdateSVGpath,
  UploadIcon: UploadIcon,
  UploadSVGpath: UploadSVGpath,
  VerticalDotsCircleIcon: VerticalDotsCircleIcon,
  VerticalDotsCircleSVGpath: VerticalDotsCircleSVGpath,
  VerticalDotsCircleSolidIcon: VerticalDotsCircleSolidIcon,
  VerticalDotsCircleSolidSVGpath: VerticalDotsCircleSolidSVGpath,
  VerticalDotsIcon: VerticalDotsIcon,
  VerticalDotsSVGpath: VerticalDotsSVGpath,
  WaringOutlineIcon: WaringOutlineIcon,
  WaringOutlineSVGpath: WaringOutlineSVGpath,
  WarningIcon: WarningIcon,
  WarningOutlineIcon: WarningOutlineIcon,
  WarningOutlineSVGpath: WarningOutlineSVGpath,
  WarningSVGpath: WarningSVGpath,
  WarningStopIcon: WarningStopIcon,
  WarningStopSVGpath: WarningStopSVGpath,
  WordFileIcon: WordFileIcon,
  WordFileSVGpath: WordFileSVGpath,
  XMLFileIcon: XMLFileIcon,
  XMLFileSVGpath: XMLFileSVGpath
});

const AndreForholdSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M34.519 8.316c.908 0 1.62.75 1.62 1.66V35.93a1.67 1.67 0 0 1-1.66 1.66h-.79v.79c0 .868-.672 1.58-1.501 1.58h-18.41c-.83 0-1.501-.712-1.501-1.58V12.266c0-.87.671-1.58 1.5-1.58h1.186v-.712c0-.908.75-1.659 1.66-1.659l17.896.001Zm-11.062 4.82h-8.692v24.296H31.24V21.274h-7.783v-8.138ZM19.862 25.5v3.042H16.82V25.5h3.042Zm4.661 0v3.042h-3.042V25.5h3.042Zm4.662 0v3.042h-3.042V25.5h3.042Zm-3.279-11.536v4.86h4.267l-4.267-4.86Z'
});
function AndreForholdIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: AndreForholdSVGpath
    });
}

const ArbeidTrygdPensjonSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm11.504 23.1 3.6 2.8c-1 .5-1.6 1.6-1.6 2.7 0 1.7 1.4 3.1 3.1 3.1h11.7c.6 0 1-.4 1-1 0-.5-.4-1-1-1h-11.8c-.6 0-1.1-.5-1.1-1.1 0-.5.3-.9.8-1l12.8-3.3 1.7-.3c.4-.1.9-.1 1.3 0l3.3 1.2 8.2-1.3v9.7l-6.8.2-.5.8c-.3.4-.7.7-1.2.8l-14.8 2.6c-.5.1-1.1-.1-1.5-.4l-14-11.5c-1.2-1-.8-2.9.7-3.2l2.3-.6c1.3-.3 2.7 0 3.8.8Zm14 0-6.9 1.8c-.6.1-1.1-.3-1.1-.9 0-.5.4-.9.9-.9h7.1Zm3.5-5.8c.6 0 1 .4 1 1V20c0 .6-.4 1-1 1h-10.6c-.6 0-1-.4-1-1v-1.7c0-.6.4-1 1-1h10.6Zm-.2-7.3c.6 0 1.1.4 1.2 1l.1 1.7c.1.6-.3 1.1-.9 1.1l-10.6.8c-.6.1-1.1-.3-1.1-.9l-.1-1.7c-.1-.6.3-1.1.9-1.1l10.5-.9Z'
});
function ArbeidTrygdPensjonIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ArbeidTrygdPensjonSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const BankLaanForsikringSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M40 6c1.1 0 2 .9 2 2v32c0 1.1-.9 2-2 2h-5.1v1h-5.7v-1H18.8v1h-5.7v-1H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h32Zm-3.7 5.8H11.7v2h23.6v20.3H11.7v2h24.6c.5 0 1-.4 1-1V12.8c0-.5-.5-1-1-1Zm-18 6.9c-2.9 0-5.3 2.4-5.3 5.3s2.4 5.3 5.3 5.3 5.3-2.4 5.3-5.3-2.4-5.3-5.3-5.3Zm.1 1c2.4 0 4.3 1.9 4.3 4.3s-2 4.3-4.3 4.3c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3Zm0 2.1c-1.2 0-2.2 1-2.2 2.2 0 1.2.9 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2Z'
});
function BankLaanForsikringIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BankLaanForsikringSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const BoligEiendelerSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M34.5 21.75c2.1 0 4.1.1 6.1.1.4.1.7.3.9.7.2.6.5 1.5.7 2.3.2.7.4 1.4.6 1.9h.6c.5 0 1 .4 1 .9v1.1c.1.3 0 .6-.2.8-.2.2-.4.3-.7.3h-.1v4.9c0 .6-.4 1-1 1h-2.5c-.6 0-1-.4-1-1v-.3c-1.5.1-2.9.1-4.4.1-1.5 0-2.9-.1-4.4-.1v.3c0 .6-.5 1-1 1h-2.5c-.6 0-1-.4-1-1v-4.8h-.1c-.3 0-.5-.1-.7-.3-.1-.3-.2-.5-.2-.8v-1.2c0-.5.5-.9 1-.9h.6c.2-.6.4-1.2.6-1.9.2-.9.5-1.7.7-2.3.1-.4.5-.7.9-.7 2.1-.1 4.1-.1 6.1-.1Zm-20.3-8.6 8.9 7.5c.2.2.4.5.4.8v13.7c0 .3-.2.5-.5.5h-5.5c-.3 0-.5-.2-.5-.5v-8.1c0-.3-.2-.5-.5-.5H11c-.3 0-.5.2-.5.5v8.1c0 .3-.2.5-.5.5H4.5c-.3 0-.5-.2-.5-.5v-13.6c0-.3.2-.6.4-.8l9-7.6c.2-.2.6-.2.8 0Zm26.3 16.2c-.6 0-1 .5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1Zm-11.9 0c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1Zm6.7-5.8h-.8c-1.7 0-3.3.1-4.9.1-.1 0-.3.1-.3.2-.3.8-.8 2.7-.9 3.5 0 .2.1.4.4.4l1.15-.049c1.546-.051 3.13-.051 4.65-.051 1.9 0 3.8.1 5.7.1.2 0 .3-.2.3-.4-.2-.9-.6-2.7-.9-3.5 0-.1-.1-.2-.3-.2-1.7-.1-3.3-.1-4.9-.1h.8Z'
});
function BoligEiendelerIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: BoligEiendelerSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const CarRecycleSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M22.1,35c0-6.63,5.37-12,12-12,3.13,0,5.97,1.21,8.11,3.17.51-.06.96-.28,1.3-.66.36-.42.54-.94.48-1.5l-.18-2.3c-.08-1.06-.98-1.88-2.04-1.88h-.12l-.96.06c-.38-1.06-.78-2.42-1.16-3.74-.46-1.64-.94-3.32-1.42-4.52-.32-.78-1.04-1.28-1.84-1.3-4.02-.08-8.1-.14-12.14-.14s-8.1.06-12.12.14c-.8.02-1.52.52-1.84,1.3-.48,1.2-.96,2.88-1.42,4.52-.38,1.32-.78,2.68-1.16,3.74l-1.04-.06h-.12c-1.06,0-1.96.82-2.04,1.88l-.18,2.3c-.06.56.12,1.08.48,1.5.36.4.84.64,1.38.68l.24.02v6.56c0,.06,0,.12.02.16-.02.06-.02.12-.02.18v2.68c0,1.12.9,2.02,2.02,2.02h5.02c1.1,0,2-.9,2-2.02v-.62c2.25.08,4.51.09,6.76.11,0-.09-.01-.18-.01-.28ZM12.21,29.49c-1.18,0-2.14-.98-2.14-2.2s.96-2.18,2.14-2.18,2.14.98,2.14,2.18-.96,2.2-2.14,2.2ZM12.67,21.83h-.04c-.48,0-.74-.38-.66-.82.24-1.68,1.14-5.32,1.72-6.96.1-.28.38-.46.7-.48,3.24-.08,6.5-.12,9.74-.12s6.5.04,9.76.12c.32.02.6.2.7.48.58,1.64,1.48,5.28,1.72,6.96.06.44-.2.82-.66.82h-.04c-3.82-.1-7.64-.16-11.48-.16s-7.64.06-11.46.16Z M42.54,34.75c-.13-4.03-3.45-7.27-7.52-7.27-1.42,0-2.8.4-4.01,1.17l-.26.17,1.68,1.68.16-.09c.73-.4,1.57-.61,2.43-.61,2.79,0,5.07,2.2,5.2,4.95h-3.07l4.24,4.24,4.24-4.24h-3.08Z M37.45,39.6c-.73.4-1.57.61-2.43.61-2.79,0-5.07-2.2-5.2-4.95h3.07l-4.24-4.24-4.24,4.24h3.08c.13,4.03,3.45,7.27,7.52,7.27,1.42,0,2.8-.4,4.01-1.17l.26-.17-1.68-1.68-.16.09Z'
});
function CarRecycleIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: CarRecycleSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const ChatbotDetailedSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M26.31 9.36c0 1.303-1.034 2.36-2.31 2.36s-2.31-1.057-2.31-2.36S22.724 7 24 7s2.31 1.057 2.31 2.36Zm-13.24 5.21h21.86c1.07 0 1.92.94 1.85 2.03l-1.57 20.66c-.08.97-.87 1.73-1.84 1.73H14.64c-.97 0-1.77-.75-1.85-1.73L11.23 16.6c-.08-1.1.77-2.03 1.84-2.03Zm3.03 13.88h1.85V23.9H16.1v4.55Zm9.13 5.05 2.1-1.95c.2-.18.06-.5-.23-.5h-6.74c-.29 0-.43.31-.23.5l2.1 1.95c.83.77 2.17.77 3 0Zm4.83-5.05h1.85V23.9h-1.85v4.55Zm9.58 1.67h1.03c.73 0 1.33-.6 1.33-1.33v-4.87c0-.73-.59-1.33-1.33-1.33h-1.03c-.73 0-1.33.59-1.33 1.33v4.87c0 .73.59 1.33 1.33 1.33Zm-32.31 0h1.03c.74 0 1.33-.6 1.33-1.34v-4.87c0-.73-.59-1.33-1.33-1.33H7.33c-.73 0-1.33.59-1.33 1.33v4.87c0 .74.6 1.34 1.33 1.34Z'
});
function ChatbotDetailedIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: ChatbotDetailedSVGpath
    });
}

const DriftsmidlerSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M43.5 24.9v-1.3c-.1-.6-.6-1.1-1.2-1.1h-.7c-.2-.6-.5-1.5-.7-2.3-.2-.8-.6-2.1-.8-2.8-.2-.4-.6-.8-1.1-.9-2.4 0-4.8-.1-7.4-.1-2.6 0-4.8 0-7.4.1-.5 0-1 .4-1.1.9-.3.9-.6 1.8-.9 2.8-.2.8-.5 1.6-.7 2.3h-.7c-.6 0-1.2.5-1.2 1.1V25c0 .3.1.7.2 1 .2.2.5.4.9.4h.1v5.8c0 .6.5 1.2 1.1 1.2h3.2c.7 0 1.2-.5 1.2-1.2v-.4c1.8 0 3.5.1 5.3.1 1.8 0 3.5 0 5.3-.1v.4c0 .6.4 1.2 1.1 1.2h3.1c.6 0 1.2-.4 1.2-1.1v-6h.1c.3 0 .6-.1.8-.4.3-.3.4-.7.3-1Zm-19.1 3.3c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3Zm7.2-4.7c-2.3 0-4.7 0-7 .1-.2 0-.5-.2-.5-.4v-.1c.2-1.4.6-2.8 1.1-4.2 0-.1.2-.2.4-.2 1.9 0 3.9-.1 5.9-.1 2 0 3.9 0 5.9.1.2 0 .4.1.4.2.4 1 .8 3.1 1.1 4.2 0 .2-.1.5-.4.5-2.3.1-4.6-.1-6.9-.1Zm7.2 4.7c-.7 0-1.3-.6-1.3-1.3.1-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3ZM6 28.9h9.4c.8 0 1.5.7 1.5 1.5v1.4c0 .8-.7 1.5-1.5 1.5H6c-.8 0-1.5-.7-1.5-1.5v-1.4c0-.8.6-1.5 1.5-1.5Zm0-6.2h9.4c.8 0 1.5.7 1.5 1.5v1.4c0 .8-.7 1.5-1.5 1.5H6c-.8 0-1.5-.7-1.5-1.5v-1.4c0-.8.6-1.5 1.5-1.5Zm10-6.2-9.2-1.9h-.3c-.7 0-1.3.5-1.5 1.2l-.3 1.4c-.1.8.4 1.6 1.2 1.7l9.2 1.9h.3c.7 0 1.3-.5 1.5-1.2l.3-1.4c.1-.7-.4-1.5-1.2-1.7Z'
});
function DriftsmidlerIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: DriftsmidlerSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const DrosjeServeringSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M18.9 19H4c-.8 0-1.5.6-1.5 1.4v8.7c0 2.6 2.1 4.6 4.6 4.6h3.7c2.6 0 4.6-2.1 4.6-4.6v-1.6h.9c2.2 0 4.1-1.8 4.1-4.1v-2.9c.1-.8-.6-1.5-1.5-1.5Zm-.5 4.5c0 1.1-.9 2-2 2h-.9v-4.4h2.9v2.4Zm28.1 1.9v-1.3c-.1-.6-.6-1.1-1.2-1.1h-.7c-.2-.6-.5-1.5-.7-2.3-.2-.8-.6-2.1-.8-2.8-.2-.4-.6-.8-1.1-.9-1.2 0-2.4 0-3.7-.1V15c0-.6-.4-1-1-1h-5.5c-.6 0-1 .4-1 1v2c-1.2 0-2.4 0-3.6.1-.5 0-.9.4-1.1.9-.3.9-.6 1.8-.9 2.8-.2.8-.5 1.6-.7 2.3h-.7c-.6 0-1.2.5-1.2 1.1v1.5c0 .3.1.7.2 1 .2.2.5.4.9.4h.1v5.8c0 .6.5 1.2 1.1 1.2H28c.7 0 1.2-.5 1.2-1.2v-.4c1.8 0 3.5.1 5.3.1 1.8 0 3.5 0 5.3-.1v.4c0 .6.4 1.2 1.1 1.2H44c.6 0 1.2-.4 1.2-1.1v-6h.1c.3 0 .6-.1.8-.4.4-.5.5-.9.4-1.2Zm-19.1 3.4c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3Zm10.8-1.2h-1.5v1.5h-1.5v-1.5h-1.5v1.5h-1.5v-1.5h-1.5v-1.5h1.5v1.5h1.5v-1.5h1.5v1.5h1.5v-1.5h1.5v1.5Zm-3.6-3.5c-2.3 0-4.7 0-7 .1-.2 0-.5-.2-.5-.4v-.1c.2-1.4.6-2.8 1.1-4.2 0-.1.2-.2.4-.2 1.9 0 3.9-.1 5.9-.1 2 0 3.9 0 5.9.1.2 0 .4.1.4.2.4 1.4.8 2.8 1.1 4.2 0 .2-.1.5-.4.5-2.3 0-4.6-.1-6.9-.1Zm7.2 4.7c-.7 0-1.3-.6-1.3-1.3.1-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3Z'
});
function DrosjeServeringIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: DrosjeServeringSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const EiendelerEgenkapitalGjeldSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M25.1 36c-.3-.3-.6-.4-1-.4s-.7.2-1 .4l-3.2 3c-.6.6-.6 1.5-.1 2.1.3.3.7.5 1.1.5h6.4c.8 0 1.5-.7 1.5-1.5 0-.4-.2-.8-.5-1.1l-3.2-3Zm18 .3L5.6 26c-.8-.2-1.6.3-1.8 1.1-.2.8.3 1.6 1 1.8l37.6 10.3c.1 0 .3.1.4.1.7 0 1.3-.5 1.5-1.1.1-.8-.4-1.6-1.2-1.9ZM6.4 15.6h11c.8 0 1.5.7 1.5 1.5v2c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-2c0-.9.7-1.5 1.5-1.5Zm-1.7-3.2c.1.7.8 1.2 1.5 1.2h.3l10.8-2.2c.8-.2 1.3-.9 1.2-1.8l-.4-2c-.2-.7-.8-1.2-1.5-1.2h-.3L5.4 8.6c-.8.2-1.3.9-1.2 1.8l.5 2Zm26.6 14.2h11c.8 0 1.5.7 1.5 1.5v2c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-2c0-.9.7-1.5 1.5-1.5Zm0-7h11c.8 0 1.5.7 1.5 1.5v2c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-2c0-.9.7-1.5 1.5-1.5Zm0-7h11c.8 0 1.5.7 1.5 1.5v2c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-2c0-.9.7-1.5 1.5-1.5Z'
});
function EiendelerEgenkapitalGjeldIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: EiendelerEgenkapitalGjeldSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const FinansSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M6 7c.6 0 1 .4 1 1v31h2.5V26c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v13h2v-9c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v9h2.1V24c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v15h2.1V18c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v21H42c.6 0 1.1.4 1.1 1s-.4 1-1 1H6c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1Zm30 1.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-8.1 7.8c-.1.1-.2.2-.3.2l-8.1 3.4c-.1.1-.3.1-.4.1-.2 0-.4-.1-.6-.2l-6.1-5-4 2.4c-.4.3-1 .2-1.3-.3-.3-.5-.2-1.1.3-1.4l4.5-2.8c.4-.2.9-.2 1.2.1l6.2 5 7.4-3.1L36 8.9Z'
});
function FinansIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: FinansSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const GaveArvSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M30 7c1.4 0 2.9.6 4 1.7 2.2 2.2 2.2 5.8 0 8-1.5 1.5-4 2.2-6.3 2.6H41V42H7V19.3h13.1c-2.2-.3-4.8-1.1-6.3-2.6-2.2-2.2-2.2-5.8 0-8 1.1-1.1 2.5-1.7 4-1.7 1.4 0 2.9.6 4 1.7 1 1 1.7 2.4 2.1 3.9.5-1.5 1.1-2.9 2.1-3.9C27.1 7.6 28.6 7 30 7Zm3.4 16H14.5c0 2.1-1.7 3.8-3.8 3.8v7.6c2.1 0 3.8 1.7 3.8 3.8h18.9c0-2.1 1.7-3.8 3.8-3.8v-7.6a3.796 3.796 0 0 1-3.8-3.8ZM24 25a5.7 5.7 0 1 1 0 11.4A5.7 5.7 0 0 1 24 25Zm6.1-15a2.73 2.73 0 0 0-1.9.8c-1.1 1-1.7 3.4-1.9 5.8 2.4-.3 4.7-1 5.7-2 1-1.1 1-2.8 0-3.8-.5-.5-1.2-.8-1.9-.8Zm-12.2 0c-.7 0-1.4.3-1.9.8-1 1-1 2.7.1 3.7 1 1 3.3 1.7 5.7 2-.3-2.3-1-4.7-2-5.7-.5-.5-1.2-.8-1.9-.8Z'
});
function GaveArvIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: GaveArvSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const InntektSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M10.4 34h11c.8 0 1.5.7 1.5 1.5V39c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-3.5c0-.8.7-1.5 1.5-1.5Zm0-8h11c.8 0 1.5.7 1.5 1.5V31c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-3.5c0-.8.7-1.5 1.5-1.5Zm0-8h11c.8 0 1.5.7 1.5 1.5V23c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-3.5c0-.8.7-1.5 1.5-1.5Zm27.2 16h-11c-.8 0-1.5.7-1.5 1.5V39c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-3.5c0-.8-.7-1.5-1.5-1.5Zm-.5 4.5h-10V36h10v2.5Zm.5-12.5h-11c-.8 0-1.5.7-1.5 1.5V31c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-3.5c0-.8-.7-1.5-1.5-1.5Zm-.5 4.5h-10V28h10v2.5Zm.5-12.5h-11c-.8 0-1.5.7-1.5 1.5V23c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-3.5c0-.8-.7-1.5-1.5-1.5Zm-.5 4.5h-10V20h10v2.5ZM23 10.4 12.4 7.6c-.1 0-.2-.1-.4-.1-.7 0-1.3.5-1.4 1.1L9.7 12c-.2.8.3 1.6 1.1 1.8l10.6 2.8c.1 0 .3.1.4 0 .7 0 1.3-.5 1.5-1.1l.9-3.4c.1-.7-.4-1.5-1.2-1.7Z'
});
function InntektIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: InntektSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const KredittfradragSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M23.1 6.043v8.143a9.765 9.765 0 0 0-8.743 9.728c0 5.4 4.372 9.772 9.772 9.772a9.64 9.64 0 0 0 6.128-2.186L36 37.2c-3.171 2.829-7.329 4.543-11.871 4.543-9.858 0-17.872-8.014-17.872-17.872 0-9.514 7.457-17.314 16.843-17.828Zm18.9 18.9c-.257 4.114-1.929 7.886-4.5 10.8L31.757 30c1.157-1.414 1.886-3.129 2.1-5.057H42Zm-14.657-1.5c1.328 0 2.271.986 2.271 2.571 0 1.586-.943 2.572-2.271 2.572-1.329 0-2.272-1.029-2.272-2.572 0-1.585.986-2.571 2.272-2.571Zm-.086-3.943-4.543 8.871H21.6l4.543-8.871h1.114Zm.086 4.929c-.6 0-.9.642-.9 1.585 0 .9.3 1.586.9 1.586.6-.043.9-.686.9-1.586 0-.943-.3-1.585-.9-1.585Zm-5.829-5.1c1.329 0 2.272.985 2.272 2.571 0 1.586-.943 2.571-2.272 2.571-1.285 0-2.271-1.028-2.271-2.571 0-1.586.986-2.571 2.271-2.571Zm0 .985c-.6 0-.9.643-.9 1.586 0 .9.3 1.586.9 1.586.643 0 .9-.643.9-1.586 0-.943-.3-1.586-.9-1.586ZM25.2 6.043c9 .514 16.243 7.757 16.757 16.8h-8.1c-.471-4.586-4.114-8.229-8.657-8.7v-8.1Zm1.757 1.971V12.6a11.598 11.598 0 0 1 8.4 8.4h4.586c-1.157-6.6-6.386-11.829-12.986-12.986Z'
});
function KredittfradragIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: KredittfradragSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const MvaFastsettingSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M12.33 7h11l8.31 8.22v7a12.107 12.107 0 0 0-1.21-.07 11.32 11.32 0 0 0-1.55.11v-5.62H22V9.75h-9.69v22h7.13a11.864 11.864 0 0 0 0 2.75h-7.13a2.76 2.76 0 0 1-2.76-2.75v-22A2.76 2.76 0 0 1 12.33 7Zm3.45 11.295a2.65 2.65 0 0 1 1.09-.215A2.661 2.661 0 0 1 19.56 21a2.69 2.69 0 1 1-5.37 0 2.65 2.65 0 0 1 1.59-2.705Zm.19 2.695c0 .98.27 1.64.9 1.64h-.03c.62.04.92-.67.92-1.64 0-.97-.26-1.71-.89-1.71s-.9.73-.9 1.71Zm6.23-2.68-5.36 9.99h1.36l5.37-9.99H22.2Zm.316 4.614c.342-.15.71-.226 1.084-.224a2.549 2.549 0 0 1 2.01.88c-.464.242-.909.52-1.33.83a.76.76 0 0 0-.68-.5c-.62 0-.89.67-.89 1.67v.22a11.808 11.808 0 0 0-1.26 1.63 3.08 3.08 0 0 1-.53-1.81 2.68 2.68 0 0 1 1.596-2.696ZM30.79 43a9.66 9.66 0 1 1 9.66-9.66A9.67 9.67 0 0 1 30.79 43Zm0-16.53a6.87 6.87 0 1 0 6.86 6.87 6.88 6.88 0 0 0-6.86-6.87Zm-1.32 8.09 4.21 1.98.77-1.62-3.19-1.5v-4.21h-1.79v5.35Z'
});
function MvaFastsettingIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MvaFastsettingSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const MvaRegistreringerSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M13.2 11.9h2.6v8.3h16.3v-8.3h2.6l2 16.8 2.4-.3L37 9.6h-4.8V4.8H15.8v4.8H11L8.8 28.4l2.4.3 2-16.8Zm4.5-5.2h12.5v11.5H17.7V6.7Zm14.4 19.7H15.8v2.1h16.3v-2.1Zm0-4.2H15.8v2.1h16.3v-2.1Zm7.5 8.4c.2 0 .5.1.6.3.1.2.2.5.1.7l-3.5 10.6c-.2.6-.8 1-1.4 1H12.6c-.7 0-1.2-.4-1.4-1L7.7 31.6c-.1-.2 0-.5.1-.7.1-.2.4-.3.6-.3h31.2Zm-19.7 4.2h8.3v-2.1h-8.3v2.1Zm1.9-26.3c1 .1 1.8 1 1.7 2.1v.4c-.1 1-1.1 1.8-2.1 1.7-1-.1-1.8-1-1.7-2.1v-.4c.1-1 1.1-1.8 2.1-1.7Zm-.3.9c-.4 0-.6.5-.6 1.2s.2 1.2.6 1.2c.4 0 .6-.5.6-1.2s-.2-1.2-.6-1.2Zm.1 6.4 3.8-7.1h1l-3.9 7.1h-.9Zm2.9-2.1c0-1 .8-1.9 1.9-1.9h.3c1.1.1 1.8 1.1 1.7 2.1v.3c-.1 1.1-1 1.9-2.1 1.8-1.1-.1-1.9-1-1.8-2.1v-.2Zm1.3.2c0 .7.1 1.2.6 1.2s.6-.5.6-1.2-.2-1.2-.6-1.2c-.4 0-.6.5-.6 1.2Z'
});
function MvaRegistreringerIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: MvaRegistreringerSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const NaeringsinntektSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M42 19.2c0-.2-.1-.3-.3-.4-.1 0-.2 0-.3.1L35.3 24v-4.8c0-.2-.1-.3-.3-.4-.1 0-.2 0-.3.1L28.6 24V12h-3.8v24H42V19.2ZM7.5 31h11c.8 0 1.5.7 1.5 1.5v2c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-2c0-.9.7-1.5 1.5-1.5Zm0-7h11c.8 0 1.5.7 1.5 1.5v2c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-2c0-.9.7-1.5 1.5-1.5Zm11.7-7L8.4 14.8h-.3c-.7 0-1.3.5-1.5 1.2l-.4 2c-.2.8.4 1.6 1.2 1.8l10.8 2.1h.3c.7 0 1.3-.5 1.5-1.2l.4-2c.1-.7-.4-1.5-1.2-1.7Z'
});
function NaeringsinntektIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: NaeringsinntektSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const PersoninntektSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M30.2 24a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0 3c-2 0-4 .3-6 .8V36h18v-3c0-3.3-5.4-6-12-6Zm-11.9 4h-11c-.8 0-1.5.7-1.5 1.5v2c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-2c0-.8-.7-1.5-1.5-1.5Zm0-7h-11c-.8 0-1.5.7-1.5 1.5v2c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-2c0-.8-.7-1.5-1.5-1.5Zm-10-9.1 10.8 2.2c.7.1 1.3.9 1.2 1.7l-.4 2c-.2.7-.8 1.2-1.5 1.2h-.3L7.3 19.9c-.8-.2-1.4-1-1.2-1.8l.4-2c.2-.7.8-1.2 1.5-1.2h.3Z'
});
function PersoninntektIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PersoninntektSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const PersonligeForholdSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M24 4c.7 0 1.3.2 1.9.5l14.2 8.2c1.2.6 1.9 1.9 1.9 3.2v16.3c0 1.3-.7 2.5-1.9 3.2l-14.2 8.1c-.6.3-1.2.5-1.9.5s-1.3-.2-1.9-.5L7.9 35.4C6.7 34.8 6 33.5 6 32.2V15.9c0-1.4.7-2.6 1.9-3.3l14.2-8.1c.6-.3 1.2-.5 1.9-.5Zm.07 3h-.118c-.107.004-.266.029-.352.2L9.4 15.3c-.3.1-.4.3-.4.6v16.2c0 .3.1.5.4.7l14.2 8.1c.1.1.3.1.4.1.1 0 .3 0 .4-.2l14.2-8.1c.3-.1.4-.3.4-.6V15.8c0-.2-.2-.5-.4-.6L24.4 7.1c-.1-.1-.3-.1-.4-.1h.07ZM24 26.2c5 0 9.1 2 9.1 4.5V33H14.9v-2.3c0-2.5 4.1-4.5 9.1-4.5ZM24 15c2.5 0 4.6 2 4.6 4.4 0 2.4-2 4.5-4.5 4.6H24c-2.5 0-4.5-2.1-4.5-4.6 0-2.4 2-4.4 4.5-4.4Z'
});
function PersonligeForholdIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: PersonligeForholdSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const SelskapDeltakerfastsettingSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M41.708 21.957v-7.103c0-.39-.486-.681-.778-.39l-8.952 7.395h-.097v-7.102c0-.39-.486-.681-.778-.39l-8.952 7.395V14.66c0-.389-.486-.68-.778-.389l-8.951 7.395V6.097h-5.74v35.027h6.129v-1.848s0-4.67 8.173-4.67 8.173 4.67 8.173 4.67v1.848h2.335v-1.848c-.097-1.849-.973-3.503-2.433-4.67 7.103.389 7.103 4.67 7.103 4.67v1.848h5.546V21.957ZM20.984 32.562c-2.238 0-4.087-1.848-4.087-4.086 0-2.238 1.849-4.087 4.087-4.087 2.238 0 4.086 1.849 4.086 4.087 0 2.238-1.848 4.086-4.086 4.086Zm7.005 0c-.778 0-1.557-.194-2.238-.68a5.845 5.845 0 0 0 0-6.812c.681-.486 1.46-.68 2.238-.68 2.238 0 4.087 1.848 4.087 4.086 0 2.238-1.849 4.086-4.087 4.086Z'
});
function SelskapDeltakerfastsettingIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SelskapDeltakerfastsettingSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const SkogfondSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'm40.12 37-2.78-7.38h1.54a.51.51 0 0 0 .46-.72L33.25 16h1.68a.5.5 0 0 0 .4-.79l-6.69-9.29a.51.51 0 0 0-.81 0l-5.55 7.68a1.5 1.5 0 0 0 .95 2.4l-1.61 3.42-3.29-4.92a.499.499 0 0 0-.84 0L10 25.74a.5.5 0 0 0 .41.78h2.05L7.89 36.94a.5.5 0 0 0 .46.7h7.72v4.64h3.68v-4.64h6.64v4.64h3.68v-4.64h9.58a.499.499 0 0 0 .47-.64Z'
});
function SkogfondIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: SkogfondSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const UtgiftSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M21.3 31.1h-11c-.8 0-1.5.7-1.5 1.5v3.5c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-3.5c0-.8-.7-1.5-1.5-1.5Zm-.5 4.5h-10v-2.5h10v2.5Zm.5-12.5h-11c-.8 0-1.5.7-1.5 1.5v3.5c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-3.5c0-.8-.7-1.5-1.5-1.5Zm-.5 4.5h-10v-2.5h10v2.5Zm.5-12.5h-11c-.8 0-1.5.7-1.5 1.5v3.5c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-3.5c0-.8-.7-1.5-1.5-1.5Zm-.5 4.5h-10v-2.5h10v2.5Zm.5-12.5h-11c-.8 0-1.5.7-1.5 1.5v3.5c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5V8.6c0-.8-.7-1.5-1.5-1.5Zm-.5 4.5h-10V9.1h10v2.5Zm5.7 11.5h11c.8 0 1.5.7 1.5 1.5v3.5c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-3.5c0-.8.6-1.5 1.5-1.5Zm0-8h11c.8 0 1.5.7 1.5 1.5v3.5c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-3.5c0-.8.6-1.5 1.5-1.5Zm11.6 19.5-10.6-2.8h-.4c-.7 0-1.3.5-1.5 1.1l-.9 3.4c-.2.8.3 1.6 1.1 1.8l10.6 2.8h.4c.7 0 1.3-.5 1.5-1.1l.9-3.4c.2-.8-.3-1.6-1.1-1.8Z'
});
function UtgiftIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: UtgiftSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

const VarelagerFordringerSVGpath = /*#__PURE__*/ jsx("path", {
    d: 'M30.67 4.97h-24v5.33h24V4.97Zm-1.33 6.68v9.45h13.07v23.55l-5-2.51-4 2-4-2-4 2-5-2.5V29H8V11.65h21.34Zm-14.619 4.405a.66.66 0 0 0-.051.255v2h8v-2a.66.66 0 0 0-.67-.66h-6.66a.662.662 0 0 0-.619.405ZM37.33 39.91l3 1.5V23.1h-18v17.31l3 1.5 4-2 4 2 4-2Zm.35-13.94H25.22v2h12.46v-2Zm0 4.5H25.22v2h12.46v-2Zm0 4.5H25.22v2h12.46v-2Z'
});
function VarelagerFordringerIcon(props) {
    return /*#__PURE__*/ jsx(Icon, {
        ...props,
        svgPath: VarelagerFordringerSVGpath,
        size: 'medium',
        variant: 'themeIcon'
    });
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AndreForholdIcon: AndreForholdIcon,
  AndreForholdSVGpath: AndreForholdSVGpath,
  ArbeidTrygdPensjonIcon: ArbeidTrygdPensjonIcon,
  ArbeidTrygdPensjonSVGpath: ArbeidTrygdPensjonSVGpath,
  BankLaanForsikringIcon: BankLaanForsikringIcon,
  BankLaanForsikringSVGpath: BankLaanForsikringSVGpath,
  BoligEiendelerIcon: BoligEiendelerIcon,
  BoligEiendelerSVGpath: BoligEiendelerSVGpath,
  CarRecycleIcon: CarRecycleIcon,
  CarRecycleSVGpath: CarRecycleSVGpath,
  ChatbotDetailedIcon: ChatbotDetailedIcon,
  ChatbotDetailedSVGpath: ChatbotDetailedSVGpath,
  DriftsmidlerIcon: DriftsmidlerIcon,
  DriftsmidlerSVGpath: DriftsmidlerSVGpath,
  DrosjeServeringIcon: DrosjeServeringIcon,
  DrosjeServeringSVGpath: DrosjeServeringSVGpath,
  EiendelerEgenkapitalGjeldIcon: EiendelerEgenkapitalGjeldIcon,
  EiendelerEgenkapitalGjeldSVGpath: EiendelerEgenkapitalGjeldSVGpath,
  FinansIcon: FinansIcon,
  FinansSVGpath: FinansSVGpath,
  GaveArvIcon: GaveArvIcon,
  GaveArvSVGpath: GaveArvSVGpath,
  InntektIcon: InntektIcon,
  InntektSVGpath: InntektSVGpath,
  KredittfradragIcon: KredittfradragIcon,
  KredittfradragSVGpath: KredittfradragSVGpath,
  MvaFastsettingIcon: MvaFastsettingIcon,
  MvaFastsettingSVGpath: MvaFastsettingSVGpath,
  MvaRegistreringerIcon: MvaRegistreringerIcon,
  MvaRegistreringerSVGpath: MvaRegistreringerSVGpath,
  NaeringsinntektIcon: NaeringsinntektIcon,
  NaeringsinntektSVGpath: NaeringsinntektSVGpath,
  PersoninntektIcon: PersoninntektIcon,
  PersoninntektSVGpath: PersoninntektSVGpath,
  PersonligeForholdIcon: PersonligeForholdIcon,
  PersonligeForholdSVGpath: PersonligeForholdSVGpath,
  SelskapDeltakerfastsettingIcon: SelskapDeltakerfastsettingIcon,
  SelskapDeltakerfastsettingSVGpath: SelskapDeltakerfastsettingSVGpath,
  SkogfondIcon: SkogfondIcon,
  SkogfondSVGpath: SkogfondSVGpath,
  UtgiftIcon: UtgiftIcon,
  UtgiftSVGpath: UtgiftSVGpath,
  VarelagerFordringerIcon: VarelagerFordringerIcon,
  VarelagerFordringerSVGpath: VarelagerFordringerSVGpath
});

export { AccountArrowBackIcon, AccountArrowBackSVGpath, AccountBoxIcon, AccountBoxSVGpath, AccountChildIcon, AccountChildSVGpath, AccountEnkIcon, AccountEnkSVGpath, AccountMultipleIcon, AccountMultipleSVGpath, AddIcon, AddOutlineIcon, AddOutlineSVGpath, AddSVGpath, AndreForholdIcon, AndreForholdSVGpath, ArbeidTrygdPensjonIcon, ArbeidTrygdPensjonSVGpath, ArchiveIcon, ArchiveOutlineIcon, ArchiveOutlineSVGpath, ArchiveSVGpath, ArrowBackIcon, ArrowBackSVGpath, ArrowDownIcon, ArrowDownSVGpath, ArrowForwardIcon, ArrowForwardSVGpath, ArrowUpDownIcon, ArrowUpDownSVGpath, ArrowUpIcon, ArrowUpSVGpath, AttachFileIcon, AttachFileSVGpath, BankLaanForsikringIcon, BankLaanForsikringSVGpath, BellIcon, BellOutlineIcon, BellOutlineSVGpath, BellSVGpath, BlockedIcon, BlockedSVGpath, BoligEiendelerIcon, BoligEiendelerSVGpath, BookOpenIcon, BookOpenOutlineIcon, BookOpenOutlineSVGpath, BookOpenSVGpath, BookmarOutlinekIcon, BookmarkIcon, BookmarkOutlineSVGpath, BookmarkSVGpath, BriefcaseIcon, BriefcaseMultipleIcon, BriefcaseMultipleSVGpath, BriefcaseOffIcon, BriefcaseOffSVGpath, BriefcaseSVGpath, CalculatorIcon, CalculatorSVGpath, CalendarClockIcon, CalendarClockSVGpath, CalendarIcon, CalendarSVGpath, CancelIcon, CancelSVGpath, CarRecycleIcon, CarRecycleSVGpath, CashRefundIcon, CashRefundSVGpath, ChatBubbleIcon, ChatBubbleOutlineIcon, ChatBubbleOutlineSVGpath, ChatBubbleSVGpath, ChatbotDetailedIcon, ChatbotDetailedSVGpath, ChatbotIcon, ChatbotSVGpath, CheckIcon, CheckSVGpath, ChevronDownDoubleIcon, ChevronDownDoubleSVGpath, ChevronDownIcon, ChevronDownSVGpath, ChevronLeftDoubleIcon, ChevronLeftDoubleSVGpath, ChevronLeftIcon, ChevronLeftSVGpath, ChevronRightDoubleIcon, ChevronRightDoubleSVGpath, ChevronRightIcon, ChevronRightSVGpath, ChevronUpDoubleIcon, ChevronUpDoubleSVGpath, ChevronUpIcon, ChevronUpSVGpath, CircleDownIcon, CircleDownSVGpath, CircleFilledIcon, CircleFilledSVGpath, CircleRingIcon, CircleRingSVGpath, CircleUpIcon, CircleUpSVGpath, ClockIcon, ClockOutlineIcon, ClockOutlineSVGpath, ClockSVGpath, CloudIcon, CloudSVGpath, CloudUploadIcon, CloudUploadSVGpath, CodeIcon, CodeSVGpath, CompanyGroupIcon, CompanyGroupSVGpath, CompanyIcon, CompanySVGpath, CompletedIcon, CompletedSVGpath, CopyIcon, CopySVGpath, DeleteIcon, DeleteSVGpath, DeployIcon, DeploySVGpath, DescriptionIcon, DescriptionSVGpath, ArrowDownIcon as DownIcon, ArrowDownSVGpath as DownSVGpath, DownloadIcon, DownloadSVGpath, DriftsmidlerIcon, DriftsmidlerSVGpath, DrosjeServeringIcon, DrosjeServeringSVGpath, DuplicateIcon, DuplicateSVGpath, EarthIcon, EarthSVGpath, EditIcon, EditSVGpath, EiendelerEgenkapitalGjeldIcon, EiendelerEgenkapitalGjeldSVGpath, EmailIcon, EmailSVGpath, ErrorIcon, ErrorOutlineIcon, ErrorOutlineSVGpath, ErrorSVGpath, ExcelFileIcon, ExcelFileSVGpath, ExternalIcon, ExternalSVGpath, EyeOffIcon, EyeOffSVGpath, EyeOutlineIcon, EyeOutlineSVGpath, FacebookIcon, FacebookSVGpath, FamilyIcon, FamilySVGpath, FavoriteIcon, FavoriteOutlineIcon, FavoriteOutlineSVGpath, FavoriteSVGpath, FileIcon, FileOutlineIcon, FileOutlineSVGpath, FileSVGpath, FilterIcon, FilterSVGpath, FinansIcon, FinansSVGpath, FolkeregisterIcon, FolkeregisterOutlineIcon, FolkeregisterOutlineSVGpath, FolkeregisterSVGpath, FormatAlignLeftIcon, FormatAlignLeftSVGpath, FormatAlignRightIcon, FormatAlignRightSVGpath, ForumIcon, ForumSVGpath, GaveArvIcon, GaveArvSVGpath, HammerIcon, HammerSVGpath, HelpFilledIcon, HelpFilledSVGpath, HelpOutlineIcon, HelpOutlineSVGpath, HelpSimpleIcon, HelpSimpleSVGpath, HistoryIcon, HistorySVGpath, HomeIcon, HomeSVGpath, Icon, InfoIcon, InfoOutlineIcon, InfoOutlineSVGpath, InfoSVGpath, InfoSimpleIcon, InfoSimpleSVGpath, InfoSquareIcon, InfoSquareSVGpath, InntektIcon, InntektSVGpath, KeyIcon, KeySVGpath, KredittfradragIcon, KredittfradragSVGpath, KronerIcon, KronerSVGpath, LanPendingIcon, LanPendingSVGpath, LinkedinIcon, LinkedinSVGpath, ListAddIcon, ListAddSVGpath, ListRemoveIcon, ListRemoveSVGpath, ListReorderIcon, ListReorderSVGpath, LockIcon, LockOpenIcon, LockOpenSVGpath, LockOutlineIcon, LockOutlineOpenIcon, LockOutlineOpenSVGpath, LockOutlineSVGpath, LockSVGpath, LogOutIcon, LogOutSVGpath, MarriageIcon, MarriageSVGpath, MenuDownIcon, MenuDownSVGpath, MenuIcon, MenuSVGpath, MenuUpIcon, MenuUpSVGpath, MinusIcon, MinusSVGpath, MoreIcon, MoreSVGpath, MoveUpIcon, MoveUpSVGpath, MvaFastsettingIcon, MvaFastsettingSVGpath, MvaRegistreringerIcon, MvaRegistreringerSVGpath, NaeringsinntektIcon, NaeringsinntektSVGpath, PDFFileIcon, PDFFileSVGpath, PauseOutlineIcon, PauseOutlineSVGpath, PencilOffIcon, PencilOffSVGpath, PercentCompanyIcon, PercentCompanySVGpath, PercentIcon, PercentSVGpath, PersonIcon, PersonMoreIcon, PersonMoreOutlineIcon, PersonMoreOutlineSVGpath, PersonMoreSVGpath, PersonOutlineIcon, PersonOutlineSVGpath, PersonSVGpath, PersoninntektIcon, PersoninntektSVGpath, PersonligeForholdIcon, PersonligeForholdSVGpath, PhoneIcon, PhoneSVGpath, PinIcon, PinSVGpath, PinoffIcon, PinoffSVGpath, PlayOutlineIcon, PlayOutlineSVGpath, PreviewFileIcon, PreviewFileSVGpath, PrintIcon, PrintSVGpath, SaveIcon, SaveSVGpath, SearchIcon, SearchSVGpath, SelskapDeltakerfastsettingIcon, SelskapDeltakerfastsettingSVGpath, SendIcon, SendSVGpath, SettingsIcon, SettingsSVGpath, ShareIcon, ShareSVGpath, SkattetrekkIcon, SkattetrekkSVGpath, SkogfondIcon, SkogfondSVGpath, SoeknadIcon, SoeknadSVGpath, SortAscIcon, SortAscSVGpath, SortDefaultIcon, SortDefaultSVGpath, SortDescIcon, SortDescSVGpath, ArrowDownIcon as SortDownIcon, ArrowDownSVGpath as SortDownSVGpath, ArrowUpIcon as SortUpIcon, ArrowUpSVGpath as SortUpSVGpath, index$1 as SystemSVGPathsAndIcons, index as ThemeSVGPathsAndIcons, TimelapseIcon, TimelapseSVGpath, TimelineIcon, TimelineSVGpath, TimersandIcon, TimersandSVGpath, TwitterIcon, TwitterSVGpath, UndoIcon, UndoSVGpath, ArrowUpIcon as UpIcon, ArrowUpSVGpath as UpSVGpath, UpdateIcon, UpdateSVGpath, UploadIcon, UploadSVGpath, UtgiftIcon, UtgiftSVGpath, VarelagerFordringerIcon, VarelagerFordringerSVGpath, VerticalDotsCircleIcon, VerticalDotsCircleSVGpath, VerticalDotsCircleSolidIcon, VerticalDotsCircleSolidSVGpath, VerticalDotsIcon, VerticalDotsSVGpath, WaringOutlineIcon, WaringOutlineSVGpath, WarningIcon, WarningOutlineIcon, WarningOutlineSVGpath, WarningSVGpath, WarningStopIcon, WarningStopSVGpath, WordFileIcon, WordFileSVGpath, XMLFileIcon, XMLFileSVGpath, iconVariantArr };
